/**
 * GENERATED CODE - DO NOT MODIFY
 *
 * Raw Streamplace lexicon documents, produced by scripts/gen-raw-lexicons.mjs.
 * Run `make js-lexicons` to regenerate.
 */
import type { LexiconDoc } from "@atproto/lexicon";

export const schemas = [
  {
    "id": "games.gamesgamesgamesgames.defs",
    "defs": {
      "mode": {
        "type": "string",
        "knownValues": [
          "battleRoyale",
          "cooperative",
          "mmo",
          "multiplayer",
          "singlePlayer",
          "splitScreen"
        ]
      },
      "genre": {
        "type": "string",
        "knownValues": [
          "fighting",
          "music",
          "platform",
          "pointAndClick",
          "puzzle",
          "racing",
          "rpg",
          "rts",
          "shooter",
          "simulator"
        ]
      },
      "theme": {
        "type": "string",
        "knownValues": [
          "4x",
          "action",
          "business",
          "comedy",
          "drama",
          "educational",
          "erotic",
          "fantasy",
          "historical",
          "horror",
          "kids",
          "mystery",
          "nonfiction",
          "openWorld",
          "party",
          "romance",
          "sandbox",
          "scifi",
          "stealth",
          "survival",
          "thriller",
          "warfare"
        ]
      },
      "release": {
        "type": "object",
        "properties": {
          "platform": {
            "type": "string",
            "description": "Free-text platform name, used when no platform record exists."
          },
          "platformUri": {
            "type": "string",
            "format": "at-uri",
            "description": "AT URI of a platform record."
          },
          "releaseDates": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#releaseDate",
              "type": "ref"
            }
          }
        }
      },
      "website": {
        "type": "object",
        "required": [
          "url"
        ],
        "properties": {
          "url": {
            "type": "string",
            "format": "uri"
          },
          "type": {
            "type": "string",
            "knownValues": [
              "official",
              "wiki",
              "steam",
              "gog",
              "epicGames",
              "itchIo",
              "twitter",
              "instagram",
              "youtube",
              "twitch",
              "discord",
              "reddit",
              "facebook",
              "wikipedia",
              "bluesky",
              "xbox",
              "playstation",
              "nintendo",
              "meta",
              "other"
            ]
          }
        }
      },
      "gameView": {
        "type": "object",
        "required": [
          "uri",
          "name",
          "applicationType"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string"
          },
          "slug": {
            "type": "string"
          },
          "media": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#mediaItem",
              "type": "ref"
            }
          },
          "genres": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#genre",
              "type": "ref"
            }
          },
          "themes": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#theme",
              "type": "ref"
            }
          },
          "viewer": {
            "ref": "games.gamesgamesgamesgames.defs#viewerState",
            "type": "ref"
          },
          "summary": {
            "type": "string"
          },
          "releases": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#release",
              "type": "ref"
            }
          },
          "likeCount": {
            "type": "integer",
            "minimum": 0
          },
          "applicationType": {
            "ref": "games.gamesgamesgamesgames.defs#applicationType",
            "type": "ref"
          }
        }
      },
      "itchIoId": {
        "type": "object",
        "required": [
          "developer",
          "game"
        ],
        "properties": {
          "game": {
            "type": "string"
          },
          "developer": {
            "type": "string"
          }
        }
      },
      "ageRating": {
        "type": "object",
        "required": [
          "organization",
          "rating"
        ],
        "properties": {
          "rating": {
            "type": "string"
          },
          "organization": {
            "type": "string",
            "knownValues": [
              "esrb",
              "pegi",
              "cero",
              "usk",
              "grac",
              "classInd",
              "acb"
            ]
          },
          "contentDescriptors": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        }
      },
      "mediaItem": {
        "type": "object",
        "properties": {
          "blob": {
            "type": "blob",
            "accept": [
              "image/*",
              "video/*"
            ],
            "maxSize": 200000000
          },
          "title": {
            "type": "string"
          },
          "width": {
            "type": "integer"
          },
          "height": {
            "type": "integer"
          },
          "locale": {
            "type": "string"
          },
          "mediaType": {
            "enum": [
              "accoladesTrailer",
              "announcementTrailer",
              "artwork",
              "cinematicTrailer",
              "conceptArt",
              "cover",
              "coverAlt",
              "coverHistorical",
              "coverSquare",
              "cutscene",
              "devDiary",
              "gameplayImage",
              "gameplayTrailer",
              "icon",
              "infographic",
              "intro",
              "keyArt",
              "keyArtLogo",
              "launchTrailer",
              "logoBlack",
              "logoColor",
              "logoWhite",
              "releaseDateTrailer",
              "screenshot",
              "teaser",
              "trailer"
            ],
            "type": "string"
          },
          "description": {
            "type": "string"
          }
        }
      },
      "signature": {
        "type": "object",
        "required": [
          "key",
          "signature"
        ],
        "properties": {
          "key": {
            "type": "string",
            "description": "DID key reference (e.g., did:web:example.com#signing1)."
          },
          "signature": {
            "type": "bytes",
            "description": "The signature bytes."
          }
        },
        "description": "An inline attestation signature."
      },
      "systemSpec": {
        "type": "object",
        "properties": {
          "os": {
            "type": "string"
          },
          "memory": {
            "type": "string"
          },
          "directx": {
            "type": "string"
          },
          "storage": {
            "type": "string"
          },
          "graphics": {
            "type": "string"
          },
          "processor": {
            "type": "string"
          },
          "soundCard": {
            "type": "string"
          },
          "additionalNotes": {
            "type": "string"
          }
        },
        "description": "Hardware/software specification for a platform."
      },
      "timeToBeat": {
        "type": "object",
        "properties": {
          "hastily": {
            "type": "integer"
          },
          "normally": {
            "type": "integer"
          },
          "completely": {
            "type": "integer"
          }
        }
      },
      "companyRole": {
        "type": "string",
        "knownValues": [
          "developer",
          "publisher",
          "porter",
          "supporter"
        ]
      },
      "creditEntry": {
        "type": "object",
        "required": [
          "role"
        ],
        "properties": {
          "role": {
            "ref": "games.gamesgamesgamesgames.defs#individualRole",
            "type": "ref"
          },
          "department": {
            "type": "string",
            "maxLength": 640
          }
        }
      },
      "externalIds": {
        "type": "object",
        "properties": {
          "gog": {
            "type": "string"
          },
          "igdb": {
            "type": "string"
          },
          "xbox": {
            "type": "string"
          },
          "steam": {
            "type": "string"
          },
          "itchIo": {
            "ref": "games.gamesgamesgamesgames.defs#itchIoId",
            "type": "ref"
          },
          "twitch": {
            "type": "string"
          },
          "epicGames": {
            "type": "string"
          },
          "googlePlay": {
            "type": "string"
          },
          "playStation": {
            "type": "string"
          },
          "humbleBundle": {
            "type": "string"
          },
          "appleAppStore": {
            "type": "string"
          },
          "nintendoEshop": {
            "type": "string"
          }
        }
      },
      "releaseDate": {
        "type": "object",
        "properties": {
          "region": {
            "type": "string",
            "knownValues": [
              "worldwide",
              "europe",
              "northAmerica",
              "australia",
              "newZealand",
              "japan",
              "china",
              "asia",
              "korea",
              "brazil"
            ]
          },
          "status": {
            "type": "string",
            "knownValues": [
              "advancedAccess",
              "alpha",
              "beta",
              "cancelled",
              "digitalCompatibilityRelease",
              "earlyAccess",
              "nextGenOptimizationRelease",
              "offline",
              "release"
            ]
          },
          "releasedAt": {
            "type": "string"
          },
          "releasedAtFormat": {
            "enum": [
              "YYYY-MM-DD",
              "YYYY-MM",
              "YYYY-Q1",
              "YYYY-Q2",
              "YYYY-Q3",
              "YYYY-Q4",
              "YYYY",
              "TBD"
            ],
            "type": "string"
          }
        }
      },
      "viewerState": {
        "type": "object",
        "properties": {
          "like": {
            "type": "string",
            "format": "at-uri"
          }
        }
      },
      "externalVideo": {
        "type": "object",
        "required": [
          "videoId",
          "platform"
        ],
        "properties": {
          "title": {
            "type": "string"
          },
          "videoId": {
            "type": "string"
          },
          "platform": {
            "type": "string",
            "knownValues": [
              "youtube",
              "twitch",
              "vimeo"
            ]
          }
        }
      },
      "orgCreditView": {
        "type": "object",
        "required": [
          "uri",
          "roles"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "roles": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#companyRole",
              "type": "ref"
            }
          },
          "orgUri": {
            "type": "string",
            "format": "at-uri"
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          }
        }
      },
      "gameDetailView": {
        "type": "object",
        "required": [
          "name",
          "uri",
          "createdAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string"
          },
          "slug": {
            "type": "string"
          },
          "media": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#mediaItem",
              "type": "ref"
            }
          },
          "modes": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#mode",
              "type": "ref"
            }
          },
          "genres": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#genre",
              "type": "ref"
            }
          },
          "parent": {
            "type": "string",
            "format": "at-uri"
          },
          "themes": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#theme",
              "type": "ref"
            }
          },
          "videos": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#externalVideo",
              "type": "ref"
            }
          },
          "engines": {
            "type": "array",
            "items": {
              "type": "string",
              "format": "at-uri"
            }
          },
          "summary": {
            "type": "string"
          },
          "keywords": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "releases": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#release",
              "type": "ref"
            }
          },
          "websites": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#website",
              "type": "ref"
            }
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          },
          "storyline": {
            "type": "string"
          },
          "ageRatings": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#ageRating",
              "type": "ref"
            }
          },
          "orgCredits": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#orgCreditView",
              "type": "ref"
            }
          },
          "timeToBeat": {
            "ref": "games.gamesgamesgamesgames.defs#timeToBeat",
            "type": "ref"
          },
          "collections": {
            "type": "array",
            "items": {
              "type": "string",
              "format": "at-uri"
            }
          },
          "externalIds": {
            "ref": "games.gamesgamesgamesgames.defs#externalIds",
            "type": "ref"
          },
          "publishedAt": {
            "type": "string",
            "format": "datetime"
          },
          "actorCredits": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#actorCreditView",
              "type": "ref"
            }
          },
          "applicationType": {
            "ref": "games.gamesgamesgamesgames.defs#applicationType",
            "type": "ref"
          },
          "alternativeNames": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#alternativeName",
              "type": "ref"
            }
          },
          "languageSupports": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#languageSupport",
              "type": "ref"
            }
          },
          "multiplayerModes": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#multiplayerMode",
              "type": "ref"
            }
          },
          "playerPerspectives": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#playerPerspective",
              "type": "ref"
            }
          }
        }
      },
      "individualRole": {
        "type": "string",
        "knownValues": [
          "director",
          "producer",
          "designer",
          "programmer",
          "artist",
          "animator",
          "writer",
          "composer",
          "soundDesigner",
          "voiceActor",
          "qa",
          "localization",
          "communityManager",
          "marketing"
        ]
      },
      "actorCreditView": {
        "type": "object",
        "required": [
          "uri",
          "credits"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "credits": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#creditEntry",
              "type": "ref"
            }
          },
          "actorUri": {
            "type": "string",
            "format": "at-uri"
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          }
        }
      },
      "alternativeName": {
        "type": "object",
        "required": [
          "name"
        ],
        "properties": {
          "name": {
            "type": "string"
          },
          "locale": {
            "type": "string"
          },
          "comment": {
            "type": "string"
          }
        }
      },
      "applicationType": {
        "enum": [
          "addon",
          "bundle",
          "dlc",
          "episode",
          "expandedGame",
          "expansion",
          "fork",
          "game",
          "mod",
          "port",
          "remake",
          "remaster",
          "season",
          "standaloneExpansion",
          "update"
        ],
        "type": "string"
      },
      "gameSummaryView": {
        "type": "object",
        "required": [
          "uri",
          "name"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string"
          },
          "slug": {
            "type": "string"
          },
          "media": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#mediaItem",
              "type": "ref"
            }
          },
          "summary": {
            "type": "string"
          },
          "applicationType": {
            "ref": "games.gamesgamesgamesgames.defs#applicationType",
            "type": "ref"
          },
          "firstReleaseDate": {
            "type": "integer",
            "description": "Earliest release date as YYYYMMDD integer."
          }
        }
      },
      "languageSupport": {
        "type": "object",
        "required": [
          "language"
        ],
        "properties": {
          "audio": {
            "type": "boolean"
          },
          "language": {
            "type": "string"
          },
          "interface": {
            "type": "boolean"
          },
          "subtitles": {
            "type": "boolean"
          }
        }
      },
      "multiplayerMode": {
        "type": "object",
        "properties": {
          "platform": {
            "type": "string"
          },
          "hasDropIn": {
            "type": "boolean"
          },
          "onlineMax": {
            "type": "integer"
          },
          "hasLanCoop": {
            "type": "boolean"
          },
          "offlineMax": {
            "type": "integer"
          },
          "onlineCoopMax": {
            "type": "integer"
          },
          "hasSplitscreen": {
            "type": "boolean"
          },
          "offlineCoopMax": {
            "type": "integer"
          },
          "hasCampaignCoop": {
            "type": "boolean"
          },
          "hasSplitscreenOnline": {
            "type": "boolean"
          }
        }
      },
      "platformVersion": {
        "type": "object",
        "required": [
          "name"
        ],
        "properties": {
          "os": {
            "type": "string"
          },
          "cpu": {
            "type": "string"
          },
          "gpu": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "media": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#mediaItem",
              "type": "ref"
            }
          },
          "memory": {
            "type": "string"
          },
          "output": {
            "type": "string"
          },
          "storage": {
            "type": "string"
          },
          "summary": {
            "type": "string"
          },
          "connectivity": {
            "type": "string"
          },
          "maxResolution": {
            "type": "string"
          }
        }
      },
      "activityFeedItem": {
        "type": "object",
        "required": [
          "type",
          "createdAt"
        ],
        "properties": {
          "game": {
            "ref": "games.gamesgamesgamesgames.defs#gameView",
            "type": "ref",
            "description": "The game associated with this activity."
          },
          "list": {
            "ref": "games.gamesgamesgamesgames.defs#activityListView",
            "type": "ref",
            "description": "List data, present when type is 'listCreate' or 'listAddGame'."
          },
          "type": {
            "type": "string",
            "description": "The type of activity.",
            "knownValues": [
              "like",
              "review",
              "listCreate",
              "listAddGame"
            ]
          },
          "review": {
            "ref": "games.gamesgamesgamesgames.defs#activityReviewView",
            "type": "ref",
            "description": "Review data, present when type is 'review'."
          },
          "createdAt": {
            "type": "string",
            "format": "datetime",
            "description": "When the activity occurred."
          }
        }
      },
      "activityListView": {
        "type": "object",
        "required": [
          "uri",
          "name",
          "createdAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string"
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          }
        }
      },
      "gameFeedViewItem": {
        "type": "object",
        "required": [
          "game"
        ],
        "properties": {
          "game": {
            "ref": "games.gamesgamesgamesgames.defs#gameView",
            "type": "ref"
          },
          "feedContext": {
            "type": "string",
            "maxLength": 2000
          }
        }
      },
      "platformCategory": {
        "type": "string",
        "knownValues": [
          "console",
          "portable",
          "computer",
          "arcade",
          "operatingSystem"
        ]
      },
      "platformFeatures": {
        "type": "object",
        "required": [
          "platform",
          "features"
        ],
        "properties": {
          "features": {
            "type": "array",
            "items": {
              "type": "string",
              "knownValues": [
                "achievements",
                "cloudSaves",
                "controllerSupport",
                "controllerSupportFull",
                "coop",
                "coopLan",
                "coopOnline",
                "crossPlatformMultiplayer",
                "familySharing",
                "inAppPurchases",
                "leaderboards",
                "levelEditor",
                "moddingSupport",
                "multiPlayer",
                "multiPlayerLan",
                "multiPlayerOnline",
                "pvp",
                "pvpLan",
                "pvpOnline",
                "remotePlayPhone",
                "remotePlayTablet",
                "remotePlayTV",
                "remotePlayTogether",
                "singlePlayer",
                "steamTradingCards",
                "steamWorkshop",
                "trackingAndManagement",
                "vrSupport"
              ]
            }
          },
          "platform": {
            "type": "string",
            "knownValues": [
              "steam",
              "gog",
              "epicGames",
              "playStation",
              "xbox",
              "nintendoEshop"
            ]
          }
        },
        "description": "Features supported by a game on a specific storefront/platform."
      },
      "communityFeedItem": {
        "type": "object",
        "required": [
          "type",
          "createdAt",
          "actor"
        ],
        "properties": {
          "game": {
            "ref": "games.gamesgamesgamesgames.defs#gameView",
            "type": "ref",
            "description": "The game associated with this activity."
          },
          "list": {
            "ref": "games.gamesgamesgamesgames.defs#activityListView",
            "type": "ref",
            "description": "List data, present when type is 'listCreate' or 'listAddGame'."
          },
          "type": {
            "type": "string",
            "description": "The type of activity.",
            "knownValues": [
              "like",
              "review",
              "listCreate",
              "listAddGame"
            ]
          },
          "actor": {
            "ref": "games.gamesgamesgamesgames.defs#communityFeedActorView",
            "type": "ref",
            "description": "The user who performed this activity."
          },
          "review": {
            "ref": "games.gamesgamesgamesgames.defs#activityReviewView",
            "type": "ref",
            "description": "Review data, present when type is 'review'."
          },
          "createdAt": {
            "type": "string",
            "format": "datetime",
            "description": "When the activity occurred."
          }
        },
        "description": "A community activity item with actor information."
      },
      "engineSummaryView": {
        "type": "object",
        "required": [
          "uri",
          "name"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string"
          },
          "slug": {
            "type": "string"
          }
        }
      },
      "playerPerspective": {
        "type": "string",
        "knownValues": [
          "auditory",
          "firstPerson",
          "isometric",
          "sideView",
          "text",
          "thirdPerson",
          "topDown",
          "vr"
        ]
      },
      "activityReviewView": {
        "type": "object",
        "required": [
          "uri",
          "rating",
          "createdAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "tags": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "text": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "rating": {
            "type": "integer",
            "maximum": 10,
            "minimum": 0
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          },
          "containsSpoilers": {
            "type": "boolean"
          }
        }
      },
      "profileSummaryView": {
        "type": "object",
        "required": [
          "uri",
          "did",
          "profileType"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did"
          },
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "avatar": {
            "type": "blob",
            "accept": [
              "image/png",
              "image/jpeg"
            ],
            "maxSize": 10000000
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          },
          "profileType": {
            "type": "string",
            "knownValues": [
              "actor",
              "org"
            ]
          }
        }
      },
      "systemRequirements": {
        "type": "object",
        "required": [
          "platform"
        ],
        "properties": {
          "minimum": {
            "ref": "#systemSpec",
            "type": "ref"
          },
          "platform": {
            "type": "string",
            "knownValues": [
              "windows",
              "mac",
              "linux"
            ]
          },
          "recommended": {
            "ref": "#systemSpec",
            "type": "ref"
          }
        },
        "description": "System requirements for a game on a specific platform."
      },
      "platformSummaryView": {
        "type": "object",
        "required": [
          "uri",
          "name"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string"
          },
          "slug": {
            "type": "string"
          },
          "category": {
            "ref": "games.gamesgamesgamesgames.defs#platformCategory",
            "type": "ref"
          },
          "abbreviation": {
            "type": "string"
          }
        }
      },
      "orgProfileDetailView": {
        "type": "object",
        "required": [
          "uri",
          "did"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did"
          },
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "media": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#mediaItem",
              "type": "ref"
            }
          },
          "avatar": {
            "type": "blob",
            "accept": [
              "image/png",
              "image/jpeg"
            ],
            "maxSize": 10000000
          },
          "parent": {
            "type": "string",
            "format": "at-uri"
          },
          "status": {
            "type": "string",
            "knownValues": [
              "active",
              "inactive",
              "merged",
              "acquired",
              "defunct"
            ]
          },
          "country": {
            "type": "string"
          },
          "websites": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#website",
              "type": "ref"
            }
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          },
          "foundedAt": {
            "type": "string",
            "format": "datetime"
          },
          "description": {
            "type": "string",
            "maxLength": 3000
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          },
          "descriptionFacets": {
            "type": "array",
            "items": {
              "ref": "app.bsky.richtext.facet",
              "type": "ref"
            }
          }
        }
      },
      "skeletonGameFeedItem": {
        "type": "object",
        "required": [
          "game"
        ],
        "properties": {
          "game": {
            "type": "string",
            "format": "at-uri"
          },
          "feedContext": {
            "type": "string",
            "maxLength": 2000
          }
        }
      },
      "collectionSummaryView": {
        "type": "object",
        "required": [
          "uri",
          "name"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string"
          },
          "slug": {
            "type": "string"
          },
          "type": {
            "type": "string",
            "knownValues": [
              "franchise",
              "series",
              "curated"
            ]
          }
        }
      },
      "orgProfileSummaryView": {
        "type": "object",
        "required": [
          "uri",
          "did"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did"
          },
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "avatar": {
            "type": "blob",
            "accept": [
              "image/png",
              "image/jpeg"
            ],
            "maxSize": 10000000
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          }
        }
      },
      "actorProfileDetailView": {
        "type": "object",
        "required": [
          "uri",
          "did"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did"
          },
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "avatar": {
            "type": "blob",
            "accept": [
              "image/png",
              "image/jpeg"
            ],
            "maxSize": 10000000
          },
          "pronouns": {
            "type": "string",
            "maxLength": 200
          },
          "websites": {
            "type": "array",
            "items": {
              "ref": "games.gamesgamesgamesgames.defs#website",
              "type": "ref"
            }
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          },
          "description": {
            "type": "string",
            "maxLength": 3000
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          },
          "descriptionFacets": {
            "type": "array",
            "items": {
              "ref": "app.bsky.richtext.facet",
              "type": "ref"
            }
          }
        }
      },
      "communityFeedActorView": {
        "type": "object",
        "required": [
          "did"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did"
          },
          "handle": {
            "type": "string"
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          }
        },
        "description": "Lightweight actor view for community feed items."
      },
      "actorProfileSummaryView": {
        "type": "object",
        "required": [
          "uri",
          "did"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did"
          },
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "avatar": {
            "type": "blob",
            "accept": [
              "image/png",
              "image/jpeg"
            ],
            "maxSize": 10000000
          },
          "displayName": {
            "type": "string",
            "maxLength": 640
          }
        }
      }
    },
    "$type": "com.atproto.lexicon.schema",
    "lexicon": 1
  },
  {
    "id": "games.gamesgamesgamesgames.search",
    "defs": {
      "main": {
        "type": "query",
        "output": {
          "schema": {
            "type": "object",
            "required": [
              "results"
            ],
            "properties": {
              "cursor": {
                "type": "string"
              },
              "results": {
                "type": "array",
                "items": {
                  "refs": [
                    "games.gamesgamesgamesgames.defs#gameSummaryView",
                    "games.gamesgamesgamesgames.defs#profileSummaryView",
                    "games.gamesgamesgamesgames.defs#platformSummaryView",
                    "games.gamesgamesgamesgames.defs#collectionSummaryView",
                    "games.gamesgamesgamesgames.defs#engineSummaryView"
                  ],
                  "type": "union"
                }
              },
              "totalResults": {
                "type": "integer",
                "description": "Total number of results matching the query above the relevance threshold."
              }
            }
          },
          "encoding": "application/json"
        },
        "parameters": {
          "type": "params",
          "required": [
            "q"
          ],
          "properties": {
            "q": {
              "type": "string",
              "maxLength": 200,
              "minLength": 1
            },
            "sort": {
              "type": "string",
              "knownValues": [
                "name_asc",
                "name_desc",
                "published_asc",
                "published_desc"
              ]
            },
            "limit": {
              "type": "integer",
              "default": 20,
              "maximum": 100,
              "minimum": 1
            },
            "modes": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "types": {
              "type": "array",
              "items": {
                "type": "string",
                "knownValues": [
                  "game",
                  "profile",
                  "platform",
                  "collection",
                  "engine"
                ]
              }
            },
            "cursor": {
              "type": "string"
            },
            "genres": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "themes": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "ageRatings": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "description": "Filter game results by age rating in 'organization:rating' format (e.g. esrb:M, pegi:Eighteen)."
            },
            "includeUnrated": {
              "type": "boolean",
              "default": false,
              "description": "When age rating filters are active, also include games with no age ratings."
            },
            "applicationTypes": {
              "type": "array",
              "items": {
                "type": "string",
                "knownValues": [
                  "addon",
                  "bundle",
                  "dlc",
                  "episode",
                  "expandedGame",
                  "expansion",
                  "fork",
                  "game",
                  "mod",
                  "pack",
                  "port",
                  "remake",
                  "remaster",
                  "season",
                  "standaloneExpansion",
                  "update"
                ]
              },
              "description": "Filter game results by application type (e.g. game, dlc, bundle). Only applies when types includes game."
            },
            "includeCancelled": {
              "type": "boolean",
              "default": false
            },
            "playerPerspectives": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          }
        },
        "description": "Search across all entity types (games, profiles, platforms, collections, engines)."
      }
    },
    "$type": "com.atproto.lexicon.schema",
    "lexicon": 1
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.createGrant",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Grant a role to an account. Requires the admin role. Idempotent: granting a role an account already holds returns the existing grant.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "subject",
              "role"
            ],
            "properties": {
              "subject": {
                "type": "string",
                "description": "The account to grant to, as a DID or a handle. Handles are resolved to DIDs before the grant is written."
              },
              "role": {
                "type": "ref",
                "ref": "place.stream.access.defs#role"
              },
              "note": {
                "type": "string",
                "maxLength": 1000,
                "maxGraphemes": 100
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "grant"
            ],
            "properties": {
              "grant": {
                "type": "ref",
                "ref": "place.stream.access.defs#grantView"
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The caller is not an admin."
          },
          {
            "name": "InvalidSubject",
            "description": "The subject is neither a valid DID nor a resolvable handle."
          },
          {
            "name": "InvalidRole",
            "description": "The role is not one this node knows about."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.defs",
    "defs": {
      "role": {
        "type": "string",
        "description": "A capability a node grants to an account. admin: manage branding and access control (implies every other role). viewer: use the frontend and playback when the node is private. streamer: ingest media to this node. syndicate: have this account's media carried from other nodes. vod: upload and record VODs.",
        "knownValues": [
          "admin",
          "viewer",
          "streamer",
          "syndicate",
          "vod"
        ]
      },
      "mode": {
        "type": "string",
        "description": "How a node decides a role. open: every account holds the role. allowlist: only accounts with a grant hold the role. off: nobody holds the role (admins are always exempt).",
        "knownValues": [
          "open",
          "allowlist",
          "off"
        ]
      },
      "roleMode": {
        "type": "object",
        "required": [
          "role",
          "mode"
        ],
        "properties": {
          "role": {
            "type": "ref",
            "ref": "#role"
          },
          "mode": {
            "type": "ref",
            "ref": "#mode"
          }
        }
      },
      "grantView": {
        "type": "object",
        "description": "One account's grant of one role. Grants stored as place.stream.access.grant records in the node's access-control space carry a uri and cid; grants seeded from the node's environment (SP_ADMIN_DIDS, SP_ALLOWED_STREAMS, SP_SYNDICATE) have no uri and cannot be revoked from the API.",
        "required": [
          "subject",
          "role",
          "source"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "description": "at://{authority}/space/place.stream.access.control/self/{author}/place.stream.access.grant/{rkey} (A space URI; not validated as a classic at-uri because the space form is newer than that grammar.)"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "subject": {
            "type": "string",
            "format": "did"
          },
          "role": {
            "type": "ref",
            "ref": "#role"
          },
          "source": {
            "type": "string",
            "knownValues": [
              "space",
              "environment"
            ],
            "description": "space: a record in the access-control space, editable via the API. environment: seeded from the node's configuration."
          },
          "createdBy": {
            "type": "string",
            "format": "did",
            "description": "The admin that created the grant (the record's author)."
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          },
          "note": {
            "type": "string",
            "maxLength": 1000,
            "maxGraphemes": 100
          }
        }
      },
      "policyView": {
        "type": "object",
        "required": [
          "roles"
        ],
        "properties": {
          "roles": {
            "type": "array",
            "description": "The effective mode of every role the node knows about, including environment overrides such as SP_WIDE_OPEN and SP_DISABLE_SYNDICATION.",
            "items": {
              "type": "ref",
              "ref": "#roleMode"
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.deleteGrant",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Revoke a grant by its space URI. Requires the admin role. Grants seeded from the environment have no URI and cannot be revoked here.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "description": "(A space URI; not validated as a classic at-uri because the space form is newer than that grammar.)"
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "success"
            ],
            "properties": {
              "success": {
                "type": "boolean"
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The caller is not an admin."
          },
          {
            "name": "NotFound",
            "description": "No grant with that URI."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.getStatus",
    "defs": {
      "main": {
        "type": "query",
        "description": "Report the caller's roles on this node and the node's access policy. Works unauthenticated (roles then reflect what an anonymous visitor holds). This is the one place.stream method a node always answers, even to accounts locked out by a private viewer policy, so clients can render the right wall.",
        "parameters": {
          "type": "params",
          "properties": {
            "subject": {
              "type": "string",
              "format": "did",
              "description": "For an anonymous caller (a client holding a session this node can't attribute), the account whose chat verification to report in chatVerified. Ignored when the caller is authenticated."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "roles",
              "policy",
              "space"
            ],
            "properties": {
              "did": {
                "type": "string",
                "format": "did",
                "description": "The authenticated caller, when there is one."
              },
              "roles": {
                "type": "array",
                "description": "Every role the caller effectively holds.",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.access.defs#role"
                }
              },
              "policy": {
                "type": "ref",
                "ref": "place.stream.access.defs#policyView"
              },
              "space": {
                "type": "string",
                "description": "The node's access-control space: at://{authority}/space/place.stream.access.control/self (A space URI; not validated as a classic at-uri because the space form is newer than that grammar.)"
              },
              "chatVerifiedOnly": {
                "type": "boolean",
                "description": "Whether chat is restricted to users verified by the node's trusted verifiers (branding key chatVerifiedOnly)."
              },
              "chatVerified": {
                "type": "boolean",
                "description": "Whether the authenticated caller is verified by one of the node's trusted verifiers."
              },
              "networkMember": {
                "type": "boolean",
                "description": "Whether the caller's (or subject's) account is hosted on the network's own PDS (branding key loginPdsUrl). Absent when the node has no such PDS configured."
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.grant",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Grants one role to one account on a node. Lives in the node's access-control space (space type place.stream.access.control, skey self, authority = the broadcaster DID) and is authored by the admin who created it; until the atproto spaces implementation ships, the node stores it in statedb addressed by its at:// space URI.",
        "record": {
          "type": "object",
          "required": [
            "subject",
            "role",
            "createdAt"
          ],
          "properties": {
            "subject": {
              "type": "string",
              "format": "did",
              "description": "The account receiving the role."
            },
            "role": {
              "type": "ref",
              "ref": "place.stream.access.defs#role"
            },
            "createdAt": {
              "type": "string",
              "format": "datetime"
            },
            "note": {
              "type": "string",
              "maxLength": 1000,
              "maxGraphemes": 100,
              "description": "Free-form reminder of why the grant exists."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.listGrants",
    "defs": {
      "main": {
        "type": "query",
        "description": "List every grant on this node, including grants seeded from the environment. Requires the admin role.",
        "parameters": {
          "type": "params",
          "properties": {
            "role": {
              "type": "string",
              "description": "Only return grants of this role."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "grants"
            ],
            "properties": {
              "grants": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.access.defs#grantView"
                }
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The caller is not an admin."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.policy",
    "defs": {
      "main": {
        "type": "record",
        "key": "literal:self",
        "description": "The node's access policy: the mode of each role. A single record authored by the space authority in the node's access-control space. Roles absent from the record use the node's defaults.",
        "record": {
          "type": "object",
          "required": [
            "roles",
            "updatedAt"
          ],
          "properties": {
            "roles": {
              "type": "array",
              "items": {
                "type": "ref",
                "ref": "place.stream.access.defs#roleMode"
              }
            },
            "updatedAt": {
              "type": "string",
              "format": "datetime"
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.access.updatePolicy",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Set the mode of one or more roles. Requires the admin role. Roles not mentioned keep their current mode. The admin role cannot be changed: it is always allowlist.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "roles"
            ],
            "properties": {
              "roles": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.access.defs#roleMode"
                }
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "policy"
            ],
            "properties": {
              "policy": {
                "type": "ref",
                "ref": "place.stream.access.defs#policyView"
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The caller is not an admin."
          },
          {
            "name": "InvalidRole",
            "description": "A role or mode is not one this node knows about."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.badge.def",
    "defs": {
      "main": {
        "type": "record",
        "description": "Defines a badge's visual appearance and type. Created by the issuer and referenced by issuance records.",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "name",
            "badgeType",
            "createdAt"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 64,
              "description": "Display name for this badge."
            },
            "description": {
              "type": "string",
              "maxLength": 256,
              "description": "Optional description of the badge."
            },
            "image": {
              "type": "blob",
              "accept": [
                "image/png",
                "image/jpeg",
                "image/gif",
                "image/webp"
              ],
              "maxSize": 262144,
              "description": "Badge icon image."
            },
            "badgeType": {
              "type": "string",
              "knownValues": [
                "place.stream.badge.defs#vip",
                "place.stream.badge.defs#event"
              ],
              "description": "The category of this badge, used for scope and display rules."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime"
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.badge.defs",
    "defs": {
      "badgeView": {
        "type": "object",
        "required": [
          "badgeType",
          "issuer",
          "recipient"
        ],
        "description": "View of a badge record, with fields resolved for display. If the DID in issuer is not the current streamplace node, the signature field shall be required.",
        "properties": {
          "badgeType": {
            "type": "string",
            "knownValues": [
              "place.stream.badge.defs#mod",
              "place.stream.badge.defs#streamer",
              "place.stream.badge.defs#vip",
              "place.stream.badge.defs#event",
              "place.stream.badge.defs#bot"
            ]
          },
          "issuer": {
            "type": "string",
            "format": "did",
            "description": "DID of the badge issuer."
          },
          "recipient": {
            "type": "string",
            "format": "did",
            "description": "DID of the badge recipient."
          },
          "name": {
            "type": "string",
            "description": "Display name from the badge definition."
          },
          "description": {
            "type": "string",
            "description": "Description from the badge definition."
          },
          "imageUrl": {
            "type": "string",
            "format": "uri",
            "description": "Resolved image URL for the badge icon."
          },
          "signature": {
            "type": "string",
            "description": "TODO: Cryptographic signature of the badge (of a place.stream.key)."
          }
        }
      },
      "badgeIssuanceView": {
        "type": "object",
        "required": [
          "issuanceUri",
          "badgeType",
          "issuer"
        ],
        "description": "A resolved view of a badge issuance, including def fields for display.",
        "properties": {
          "issuanceUri": {
            "type": "string",
            "format": "at-uri",
            "description": "AT URI of the place.stream.badge.issuance record."
          },
          "issuanceCid": {
            "type": "string",
            "description": "CID of the place.stream.badge.issuance record."
          },
          "badgeType": {
            "type": "string",
            "knownValues": [
              "place.stream.badge.defs#vip",
              "place.stream.badge.defs#event"
            ]
          },
          "name": {
            "type": "string",
            "description": "Display name from the badge definition."
          },
          "description": {
            "type": "string",
            "description": "Description from the badge definition."
          },
          "imageUrl": {
            "type": "string",
            "format": "uri",
            "description": "Resolved image URL for the badge icon."
          },
          "issuer": {
            "type": "string",
            "format": "did",
            "description": "DID of the badge issuer."
          },
          "selected": {
            "type": "boolean",
            "description": "Whether this badge is currently in the user's chat profile selection."
          }
        }
      },
      "badgeSlot": {
        "type": "object",
        "required": [
          "available"
        ],
        "description": "A display slot containing available issuance-based badges and which one (if any) is currently selected.",
        "properties": {
          "selected": {
            "type": "ref",
            "ref": "#badgeIssuanceView",
            "description": "The currently selected badge in this slot, if any."
          },
          "available": {
            "type": "array",
            "description": "All badges available for this slot.",
            "items": {
              "type": "ref",
              "ref": "#badgeIssuanceView"
            }
          }
        }
      },
      "mod": {
        "type": "token",
        "description": "This user is a moderator. Displayed with a sword icon."
      },
      "streamer": {
        "type": "token",
        "description": "This user is the streamer. Displayed with a star icon."
      },
      "vip": {
        "type": "token",
        "description": "This user is a very important person."
      },
      "bot": {
        "type": "token",
        "description": "This user is a bot. Self-applied via place.stream.chat.profile selfLabels."
      },
      "event": {
        "type": "token",
        "description": "This user has won or earned a special event or contest badge."
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.badge.getIssuedBadges",
    "defs": {
      "main": {
        "type": "query",
        "description": "Returns badges issued to the authenticated user, organized by display slot. Also indicates which badges are currently selected in the user's chat profile.",
        "parameters": {
          "type": "params",
          "properties": {
            "streamer": {
              "type": "string",
              "format": "did",
              "description": "DID of the streamer channel to compute the server badge against."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "user"
            ],
            "properties": {
              "server": {
                "type": "ref",
                "ref": "place.stream.badge.defs#badgeView",
                "description": "Computed server badge (streamer, mod, or bot) for the given streamer context. Absent if the user has no server role."
              },
              "streamer": {
                "type": "ref",
                "ref": "place.stream.badge.defs#badgeSlot",
                "description": "Streamer-issued badges (e.g. VIP) available to the user."
              },
              "user": {
                "type": "ref",
                "ref": "place.stream.badge.defs#badgeSlot",
                "description": "Globally-issued cosmetic badges (e.g. event) available to the user."
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.badge.getValidBadges",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get valid badges for the authenticated user, optionally in the context of a specific streamer's chat",
        "parameters": {
          "type": "params",
          "properties": {
            "streamer": {
              "type": "string",
              "format": "did",
              "description": "Optional DID of the streamer for context-specific badges (mod, vip, etc)"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "badges"
            ],
            "properties": {
              "badges": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.badge.defs#badgeView"
                }
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.badge.issuance",
    "defs": {
      "main": {
        "type": "record",
        "description": "Grants a specific badge to a recipient. The badge only appears in chat after the recipient adds this record to their place.stream.chat.profile selection array.",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "did",
            "badge",
            "createdAt"
          ],
          "properties": {
            "did": {
              "type": "string",
              "format": "did",
              "description": "The DID of the user being granted the badge."
            },
            "badge": {
              "type": "ref",
              "ref": "com.atproto.repo.strongRef",
              "description": "Strong reference to the place.stream.badge.def record being granted."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this issuance was created."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.beta.getStatus",
    "defs": {
      "main": {
        "type": "query",
        "description": "Report an account's access status for a named beta feature: whether it has been granted (via a trusted place.stream.beta.invite, or because this node isn't beta-gating the feature), has an outstanding place.stream.beta.request, or neither. Defaults to the authenticated caller when `did` is omitted.",
        "parameters": {
          "type": "params",
          "required": [
            "feature"
          ],
          "properties": {
            "feature": {
              "type": "string",
              "description": "Identifier of the beta feature to check (e.g. \"vod\")."
            },
            "did": {
              "type": "string",
              "format": "did",
              "description": "Account to check. Defaults to the authenticated caller's DID when omitted."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "feature",
              "did",
              "status"
            ],
            "properties": {
              "feature": {
                "type": "string",
                "description": "The feature this status applies to (echoes the request)."
              },
              "did": {
                "type": "string",
                "format": "did",
                "description": "The account this status applies to."
              },
              "status": {
                "type": "string",
                "knownValues": [
                  "granted",
                  "requested",
                  "none"
                ],
                "description": "granted: the account may use the feature. requested: no grant yet, but an access request is on file. none: no grant and no request."
              }
            }
          }
        },
        "errors": [
          {
            "name": "DidRequired",
            "description": "No did supplied and the request was not authenticated, so there is no account to check."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.beta.invite",
    "defs": {
      "main": {
        "type": "record",
        "description": "Grants a single account access to a named beta feature on this network. Records live in a project-operated repo (the streamplace node's `--beta-invite-did`); operators trust invites only from that one account, by configuration. Each (did, feature) pair gets its own record so individual features can be revoked independently by deleting the corresponding record.",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "did",
            "feature",
            "createdAt"
          ],
          "properties": {
            "did": {
              "type": "string",
              "format": "did",
              "description": "Account being granted access to the named beta feature."
            },
            "feature": {
              "type": "string",
              "description": "Identifier of the beta feature being granted (e.g. \"vod\")."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this invite was issued."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.beta.request",
    "defs": {
      "main": {
        "type": "record",
        "description": "Requests access to a named beta feature on this network. Published in the requester's own repo, so the requesting account is the record's authority — there is no separate subject field. Operators index these to surface who is waiting for access; granting access is a separate place.stream.beta.invite record issued by the operator-trusted issuer. Each (requester, feature) pair gets its own record.",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "feature",
            "createdAt"
          ],
          "properties": {
            "feature": {
              "type": "string",
              "description": "Identifier of the beta feature being requested (e.g. \"vod\"). Mirrors the `feature` field on place.stream.beta.invite."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this request was made."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.branding.deleteBlob",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Delete a branding asset blob. Requires admin authorization.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "key"
            ],
            "properties": {
              "key": {
                "type": "string",
                "description": "Branding asset key (mainLogo, favicon, siteTitle, etc.)"
              },
              "broadcaster": {
                "type": "string",
                "format": "did",
                "description": "DID of the broadcaster. If not provided, uses the server's default broadcaster."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "success"
            ],
            "properties": {
              "success": {
                "type": "boolean"
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The authenticated DID is not authorized to modify branding"
          },
          {
            "name": "BrandingNotFound",
            "description": "The requested branding asset does not exist"
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.branding.exportBundle",
    "defs": {
      "main": {
        "type": "query",
        "description": "Download the node's branding as a bundle: a zip with branding.yaml (every set key; image keys name files in the zip) plus the image files. Re-import it on another node with place.stream.branding.importBundle. Requires admin authorization.",
        "parameters": {
          "type": "params",
          "properties": {
            "broadcaster": {
              "type": "string",
              "format": "did",
              "description": "DID of the broadcaster. Defaults to this node's."
            }
          }
        },
        "output": {
          "encoding": "application/zip"
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The caller is not an admin."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.branding.getBlob",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get a specific branding asset blob by key.",
        "parameters": {
          "type": "params",
          "required": [
            "key"
          ],
          "properties": {
            "key": {
              "type": "string",
              "description": "Branding asset key (mainLogo, favicon, siteTitle, etc.)"
            },
            "broadcaster": {
              "type": "string",
              "format": "did",
              "description": "DID of the broadcaster. If not provided, uses the server's default broadcaster."
            }
          }
        },
        "output": {
          "encoding": "*/*",
          "description": "Raw blob data with appropriate content-type"
        },
        "errors": [
          {
            "name": "BrandingNotFound",
            "description": "The requested branding asset does not exist"
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.branding.getBranding",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get all branding configuration for the broadcaster.",
        "parameters": {
          "type": "params",
          "required": [],
          "properties": {
            "broadcaster": {
              "type": "string",
              "format": "did",
              "description": "DID of the broadcaster. If not provided, uses the server's default broadcaster."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "assets"
            ],
            "properties": {
              "assets": {
                "type": "array",
                "description": "List of available branding assets",
                "items": {
                  "type": "ref",
                  "ref": "#brandingAsset"
                }
              }
            }
          }
        },
        "errors": []
      },
      "brandingAsset": {
        "type": "object",
        "required": [
          "key",
          "mimeType"
        ],
        "properties": {
          "key": {
            "type": "string",
            "description": "Asset key identifier"
          },
          "mimeType": {
            "type": "string",
            "description": "MIME type of the asset"
          },
          "url": {
            "type": "string",
            "description": "URL to fetch the asset blob (for images)"
          },
          "data": {
            "type": "string",
            "description": "Inline data for text assets"
          },
          "width": {
            "type": "integer",
            "description": "Image width in pixels (optional, for images only)"
          },
          "height": {
            "type": "integer",
            "description": "Image height in pixels (optional, for images only)"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.branding.importBundle",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Apply a branding bundle (see exportBundle). By default the bundle replaces the node's branding: keys it does not mention are removed. Every value is validated like updateBlob. Requires admin authorization.",
        "parameters": {
          "type": "params",
          "properties": {
            "broadcaster": {
              "type": "string",
              "format": "did",
              "description": "DID of the broadcaster. Defaults to this node's."
            },
            "merge": {
              "type": "boolean",
              "default": false,
              "description": "Keep keys the bundle does not mention instead of removing them."
            },
            "dryRun": {
              "type": "boolean",
              "default": false,
              "description": "Report what would change without writing anything."
            }
          }
        },
        "input": {
          "encoding": "application/zip"
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "applied",
              "changes"
            ],
            "properties": {
              "applied": {
                "type": "boolean",
                "description": "False for a dry run."
              },
              "changes": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "#change"
                }
              },
              "warnings": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The caller is not an admin."
          },
          {
            "name": "InvalidBundle",
            "description": "The zip, its branding.yaml or one of its values is not acceptable; the message names the key."
          }
        ]
      },
      "change": {
        "type": "object",
        "required": [
          "key",
          "action"
        ],
        "properties": {
          "key": {
            "type": "string"
          },
          "action": {
            "type": "string",
            "knownValues": [
              "added",
              "changed",
              "removed",
              "unchanged"
            ]
          },
          "detail": {
            "type": "string",
            "description": "The new text value, or the image's type and size."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.branding.updateBlob",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Update or create a branding asset blob. Requires admin authorization.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "key",
              "data",
              "mimeType"
            ],
            "properties": {
              "key": {
                "type": "string",
                "description": "Branding asset key (mainLogo, favicon, siteTitle, etc.)"
              },
              "broadcaster": {
                "type": "string",
                "format": "did",
                "description": "DID of the broadcaster. If not provided, uses the server's default broadcaster."
              },
              "data": {
                "type": "string",
                "description": "Base64-encoded blob data"
              },
              "mimeType": {
                "type": "string",
                "description": "MIME type of the blob (e.g., image/png, text/plain)"
              },
              "width": {
                "type": "integer",
                "description": "Image width in pixels (optional, for images only)"
              },
              "height": {
                "type": "integer",
                "description": "Image height in pixels (optional, for images only)"
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "success"
            ],
            "properties": {
              "success": {
                "type": "boolean"
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The authenticated DID is not authorized to modify branding"
          },
          {
            "name": "BlobTooLarge",
            "description": "The blob exceeds the maximum size limit"
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.broadcast.defs",
    "defs": {
      "broadcastOriginView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.broadcast.getBroadcaster",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get information about a Streamplace broadcaster.",
        "parameters": {
          "type": "params",
          "required": [],
          "properties": {}
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "broadcaster"
            ],
            "properties": {
              "broadcaster": {
                "type": "string",
                "format": "did",
                "description": "DID of the Streamplace broadcaster to which this server belongs"
              },
              "server": {
                "type": "string",
                "format": "did",
                "description": "DID of this particular Streamplace server"
              },
              "admins": {
                "type": "array",
                "items": {
                  "type": "string",
                  "format": "did"
                },
                "description": "Deprecated and no longer populated. Clients learn their own roles from place.stream.access.getStatus; admins manage grants via place.stream.access.*."
              }
            }
          }
        },
        "errors": []
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.broadcast.origin",
    "defs": {
      "main": {
        "type": "record",
        "key": "any",
        "description": "Record indicating a livestream is published and available for replication at a given address. By convention, the record key is streamer::server",
        "record": {
          "type": "object",
          "required": [
            "streamer",
            "server",
            "updatedAt"
          ],
          "properties": {
            "streamer": {
              "type": "string",
              "format": "did",
              "description": "DID of the streamer whose livestream is being published"
            },
            "server": {
              "type": "string",
              "format": "did",
              "description": "did of the server that's currently rebroadcasting the livestream"
            },
            "broadcaster": {
              "type": "string",
              "format": "did",
              "description": "did of the broadcaster that operates the server syndicating the livestream"
            },
            "updatedAt": {
              "type": "string",
              "format": "datetime",
              "description": "Periodically updated timestamp when this origin last saw a livestream"
            },
            "irohTicket": {
              "type": "string",
              "maxLength": 2048,
              "description": "Iroh ticket that can be used to access the livestream from the server"
            },
            "websocketURL": {
              "type": "string",
              "format": "uri",
              "description": "URL of the websocket endpoint for the livestream"
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.broadcast.syndication",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Record created by a Streamplace broadcaster to indicate that they will be replicating a livestream. NYI",
        "record": {
          "type": "object",
          "required": [
            "broadcaster",
            "streamer",
            "createdAt"
          ],
          "properties": {
            "broadcaster": {
              "type": "string",
              "format": "did",
              "description": "DID of the Streamplace broadcaster that will be replicating the livestream"
            },
            "streamer": {
              "type": "string",
              "format": "did",
              "description": "DID of the streamer whose livestream is being replicated"
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this syndication was created."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.chat.defs",
    "defs": {
      "messageView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record",
          "indexedAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          },
          "indexedAt": {
            "type": "string",
            "format": "datetime"
          },
          "chatProfile": {
            "type": "ref",
            "ref": "place.stream.chat.profile"
          },
          "replyTo": {
            "type": "union",
            "refs": [
              "#messageView"
            ]
          },
          "deleted": {
            "type": "boolean",
            "description": "If true, this message has been deleted or labeled and should be cleared from the cache"
          },
          "badges": {
            "type": "array",
            "description": "Up to 3 badge tokens to display with the message. First badge is server-controlled, remaining badges are user-settable. Tokens are looked up in badges.json for display info.",
            "maxLength": 3,
            "items": {
              "type": "ref",
              "ref": "place.stream.badge.defs#badgeView"
            }
          }
        }
      },
      "pinnedRecordView": {
        "type": "object",
        "description": "View of a pinned chat record with hydrated message data.",
        "required": [
          "uri",
          "cid",
          "record",
          "indexedAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "record": {
            "type": "ref",
            "ref": "place.stream.chat.pinnedRecord"
          },
          "indexedAt": {
            "type": "string",
            "format": "datetime"
          },
          "pinnedBy": {
            "type": "ref",
            "ref": "place.stream.chat.profile"
          },
          "message": {
            "type": "ref",
            "ref": "#messageView"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.chat.gate",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Record defining a single gated chat message.",
        "record": {
          "type": "object",
          "required": [
            "hiddenMessage"
          ],
          "properties": {
            "hiddenMessage": {
              "type": "string",
              "format": "at-uri",
              "description": "URI of the hidden chat message."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.chat.getReplay",
    "defs": {
      "main": {
        "type": "query",
        "description": "The chat of the livestream a video is the recording of, for a read-only replay beside it. Follows the video's connections to place.stream.livestream records of its own author (the records a recording is connected to when it is published as a video) and returns their messages oldest first, with the time the recording started so a player can show each message at the moment it was sent. Empty for a video that is not the recording of a livestream.",
        "parameters": {
          "type": "params",
          "required": [
            "video"
          ],
          "properties": {
            "video": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the place.stream.video record."
            },
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 1000,
              "default": 500,
              "description": "Maximum number of messages to return."
            },
            "cursor": {
              "type": "string",
              "description": "Pagination cursor from a previous response."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "messages",
              "livestreams"
            ],
            "properties": {
              "messages": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.chat.defs#messageView"
                },
                "description": "The messages, oldest first."
              },
              "livestreams": {
                "type": "array",
                "items": {
                  "type": "string",
                  "format": "at-uri"
                },
                "description": "The livestream records the messages come from, in the order they were streamed; empty when the video is not the recording of a livestream."
              },
              "startedAt": {
                "type": "string",
                "format": "datetime",
                "description": "When the recording started: the wall-clock time of the video's first moment, so a message sent at time t belongs at offset t - startedAt into the video. Absent when livestreams is empty."
              },
              "cursor": {
                "type": "string",
                "description": "Pagination cursor for the next page, if any."
              }
            }
          }
        },
        "errors": [
          {
            "name": "VideoNotFound",
            "description": "No record indexed at the supplied AT-URI."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.chat.message",
    "defs": {
      "main": {
        "type": "record",
        "description": "Record containing a Streamplace chat message.",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "text",
            "createdAt",
            "streamer"
          ],
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 3000,
              "maxGraphemes": 300,
              "description": "The primary message content. May be an empty string, if there are embeds."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this message was originally created."
            },
            "facets": {
              "type": "array",
              "description": "Annotations of text (mentions, URLs, etc)",
              "items": {
                "type": "ref",
                "ref": "place.stream.richtext.facet"
              }
            },
            "streamer": {
              "type": "string",
              "format": "did",
              "description": "The DID of the streamer whose chat this is."
            },
            "reply": {
              "type": "ref",
              "ref": "#replyRef"
            }
          }
        }
      },
      "replyRef": {
        "type": "object",
        "required": [
          "root",
          "parent"
        ],
        "properties": {
          "root": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef"
          },
          "parent": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.chat.pinnedRecord",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Record pinning a chat message for prominent display.",
        "record": {
          "type": "object",
          "required": [
            "pinnedMessage",
            "createdAt"
          ],
          "properties": {
            "pinnedMessage": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the pinned chat message."
            },
            "pinnedBy": {
              "type": "string",
              "format": "did",
              "description": "DID of the user who pinned the message."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "When this pin was created."
            },
            "expiresAt": {
              "type": "string",
              "format": "datetime",
              "description": "Optional expiration time. If set, the pin is considered inactive after this time."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.chat.profile",
    "defs": {
      "main": {
        "type": "record",
        "description": "Record containing customizations for a user's chat profile.",
        "key": "literal:self",
        "record": {
          "type": "object",
          "required": [],
          "properties": {
            "color": {
              "type": "ref",
              "ref": "#color"
            },
            "selfLabels": {
              "type": "array",
              "description": "Self-applied labels for this profile, e.g. 'bot'.",
              "maxLength": 10,
              "items": {
                "type": "ref",
                "ref": "#selfLabel"
              }
            },
            "badges": {
              "type": "ref",
              "ref": "#badgeSelections",
              "description": "Badge selections for display in chat."
            }
          }
        }
      },
      "badgeSelections": {
        "type": "object",
        "description": "Selected badges for display in chat, organized by slot.",
        "properties": {
          "streamer": {
            "type": "array",
            "description": "Selected streamer-issued badges, one per streamer channel.",
            "maxLength": 20,
            "items": {
              "type": "ref",
              "ref": "#streamerBadgeSelection"
            }
          },
          "global": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef",
            "description": "Selected globally-issued badge (e.g. event badge)."
          }
        }
      },
      "streamerBadgeSelection": {
        "type": "object",
        "description": "A selected badge for a specific streamer's channel.",
        "required": [
          "streamer",
          "badge"
        ],
        "properties": {
          "streamer": {
            "type": "string",
            "format": "did",
            "description": "DID of the streamer whose channel this selection applies to."
          },
          "badge": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef",
            "description": "Strong reference to the selected place.stream.badge.issuance record."
          }
        }
      },
      "selfLabel": {
        "type": "string",
        "description": "Label that a user can apply to their own profile.",
        "knownValues": [
          "bot"
        ]
      },
      "color": {
        "type": "object",
        "description": "Customizations for the color of a user's name in chat",
        "required": [
          "red",
          "green",
          "blue"
        ],
        "properties": {
          "red": {
            "type": "integer",
            "minimum": 0,
            "maximum": 255
          },
          "green": {
            "type": "integer",
            "minimum": 0,
            "maximum": 255
          },
          "blue": {
            "type": "integer",
            "minimum": 0,
            "maximum": 255
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.config.getEnv",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get client-facing environment configuration from the server.",
        "parameters": {
          "type": "params",
          "required": [],
          "properties": {}
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [],
            "properties": {
              "playbackWorkerUrl": {
                "type": "string",
                "description": "URL of the Cloudflare playback router worker"
              },
              "gamesEnabled": {
                "type": "boolean",
                "description": "Whether the games API is configured and available"
              }
            }
          }
        },
        "errors": []
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.defs",
    "defs": {
      "blockView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "blocker",
          "record",
          "indexedAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "blocker": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "ref",
            "ref": "app.bsky.graph.block"
          },
          "indexedAt": {
            "type": "string",
            "format": "datetime"
          }
        }
      },
      "renditions": {
        "type": "object",
        "required": [
          "renditions"
        ],
        "properties": {
          "renditions": {
            "type": "array",
            "items": {
              "type": "ref",
              "ref": "#rendition"
            }
          }
        }
      },
      "rendition": {
        "type": "object",
        "required": [
          "name"
        ],
        "properties": {
          "name": {
            "type": "string"
          }
        }
      },
      "activityGame": {
        "type": "object",
        "description": "A game from the gamesgamesgamesgames catalog, identified by its AT URI.",
        "required": [
          "uri"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "name": {
            "type": "string",
            "description": "Cached display name of the game."
          }
        }
      },
      "activityLabel": {
        "type": "object",
        "description": "A non-game activity with a well-known label.",
        "required": [
          "label"
        ],
        "properties": {
          "label": {
            "type": "string",
            "knownValues": [
              "events",
              "just_chatting",
              "podcasting",
              "music",
              "art",
              "software_dev",
              "cooking",
              "miniatures",
              "makers_crafting",
              "fitness",
              "sports"
            ]
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.game.getGame",
    "defs": {
      "main": {
        "type": "query",
        "parameters": {
          "type": "params",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "format": "at-uri"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "name"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri"
              },
              "name": {
                "type": "string"
              },
              "summary": {
                "type": "string"
              },
              "coverUrl": {
                "type": "string"
              },
              "genres": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.game.search",
    "defs": {
      "main": {
        "type": "query",
        "description": "Search for games and other entities via the games.gamesgamesgamesgames catalog. Proxied from the configured games API.",
        "parameters": {
          "type": "params",
          "required": [
            "q"
          ],
          "properties": {
            "q": {
              "type": "string",
              "minLength": 1,
              "maxLength": 200
            },
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 20
            },
            "cursor": {
              "type": "string"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "results"
            ],
            "properties": {
              "cursor": {
                "type": "string"
              },
              "totalResults": {
                "type": "integer"
              },
              "results": {
                "type": "array",
                "items": {
                  "type": "union",
                  "refs": [
                    "games.gamesgamesgamesgames.defs#gameSummaryView",
                    "games.gamesgamesgamesgames.defs#profileSummaryView",
                    "games.gamesgamesgamesgames.defs#platformSummaryView",
                    "games.gamesgamesgamesgames.defs#collectionSummaryView",
                    "games.gamesgamesgamesgames.defs#engineSummaryView"
                  ]
                }
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.getLikes",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get likes for a subject (video or comment).",
        "parameters": {
          "type": "params",
          "required": [
            "subject"
          ],
          "properties": {
            "subject": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the subject (video or comment)."
            },
            "cursor": {
              "type": "string",
              "description": "Optional pagination cursor."
            },
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 50,
              "description": "Maximum number of likes to return."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "subject",
              "count"
            ],
            "properties": {
              "subject": {
                "type": "string",
                "format": "at-uri"
              },
              "count": {
                "type": "integer",
                "minimum": 0,
                "description": "Total number of likes for this subject."
              },
              "cursor": {
                "type": "string"
              },
              "likes": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "#likeView"
                }
              }
            }
          }
        }
      },
      "likeView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record",
          "indexedAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          },
          "indexedAt": {
            "type": "string",
            "format": "datetime"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.graph.getFollowingUser",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get whether or not user A is following user B.",
        "parameters": {
          "type": "params",
          "required": [
            "userDID",
            "subjectDID"
          ],
          "properties": {
            "userDID": {
              "type": "string",
              "format": "did",
              "description": "The DID of the potentially-following user"
            },
            "subjectDID": {
              "type": "string",
              "format": "did",
              "description": "The DID of the user potentially being followed"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [],
            "properties": {
              "follow": {
                "type": "ref",
                "ref": "com.atproto.repo.strongRef"
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.ingest.defs",
    "defs": {
      "ingest": {
        "type": "object",
        "description": "An ingest URL for a Streamplace station.",
        "required": [
          "type",
          "url"
        ],
        "properties": {
          "type": {
            "type": "string",
            "description": "The type of ingest endpoint, currently 'rtmp' and 'whip' are supported."
          },
          "url": {
            "type": "string",
            "format": "uri",
            "description": "The URL of the ingest endpoint."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.ingest.getIngestUrls",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get ingest URLs for a Streamplace station.",
        "parameters": {
          "type": "params",
          "properties": {}
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "ingests"
            ],
            "properties": {
              "ingests": {
                "type": "array",
                "items": {
                  "type": "union",
                  "refs": [
                    "place.stream.ingest.defs#ingest"
                  ]
                }
              }
            }
          }
        },
        "errors": []
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.key",
    "defs": {
      "main": {
        "type": "record",
        "description": "Record linking an atproto identity with a stream signing key",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "signingKey",
            "createdAt"
          ],
          "properties": {
            "signingKey": {
              "type": "string",
              "maxLength": 57,
              "minLength": 57,
              "description": "The did:key signing key for the stream."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this key was created."
            },
            "createdBy": {
              "type": "string",
              "description": "The name of the client that created this key."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.like",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Record indicating a like on some other record (e.g. a video or a comment).",
        "record": {
          "type": "object",
          "required": [
            "subject",
            "createdAt"
          ],
          "properties": {
            "subject": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the record being liked (e.g. a place.stream.video or place.stream.vod.comment)."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this like was created."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.denyTeleport",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Deny an incoming teleport request.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri",
                "description": "The URI of the teleport record to deny."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "success"
            ],
            "properties": {
              "success": {
                "type": "boolean",
                "description": "Whether the teleport was successfully denied."
              }
            }
          }
        },
        "errors": [
          {
            "name": "TeleportNotFound",
            "description": "The specified teleport was not found."
          },
          {
            "name": "Unauthorized",
            "description": "The authenticated user is not the target of this teleport."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.getLiveUsers",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get a list of livestream segments for a user",
        "parameters": {
          "type": "params",
          "properties": {
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 50
            },
            "before": {
              "type": "string",
              "format": "datetime"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {
              "streams": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.livestream#livestreamView"
                }
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.getProfileCard",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get an OG image associated with a given account.",
        "parameters": {
          "type": "params",
          "required": [
            "id"
          ],
          "properties": {
            "id": {
              "type": "string",
              "description": "The DID or handle of the account."
            }
          }
        },
        "output": {
          "encoding": "*/*"
        },
        "errors": [
          {
            "name": "RepoNotFound"
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.getRecommendations",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get the list of streamers recommended by a user",
        "parameters": {
          "type": "params",
          "required": [
            "userDID"
          ],
          "properties": {
            "userDID": {
              "type": "string",
              "format": "did",
              "description": "The DID of the user whose recommendations to fetch"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "recommendations"
            ],
            "properties": {
              "recommendations": {
                "type": "array",
                "description": "Ordered list of recommendations",
                "items": {
                  "type": "union",
                  "refs": [
                    "#livestreamRecommendation"
                  ]
                }
              },
              "userDID": {
                "type": "string",
                "format": "did",
                "description": "The user DID this recommendation is for"
              }
            }
          }
        }
      },
      "livestreamRecommendation": {
        "type": "object",
        "required": [
          "did",
          "source"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did",
            "description": "The DID of the recommended streamer"
          },
          "source": {
            "type": "string",
            "enum": [
              "streamer",
              "follows",
              "host"
            ],
            "description": "Source of the recommendation"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.getSegments",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get a list of livestream segments for a user",
        "parameters": {
          "type": "params",
          "required": [
            "userDID"
          ],
          "properties": {
            "userDID": {
              "type": "string",
              "format": "did",
              "description": "The DID of the potentially-following user"
            },
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 50
            },
            "before": {
              "type": "string",
              "format": "datetime"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {
              "segments": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.segment#segmentView"
                }
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.recommendations",
    "defs": {
      "main": {
        "type": "record",
        "description": "A list of recommended streamers, in order of preference",
        "key": "literal:self",
        "record": {
          "type": "object",
          "required": [
            "streamers",
            "createdAt"
          ],
          "properties": {
            "streamers": {
              "type": "array",
              "description": "Ordered list of recommended streamer DIDs",
              "items": {
                "type": "string",
                "format": "did"
              },
              "maxLength": 8,
              "minLength": 0
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this list was created."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.searchActorsTypeahead",
    "defs": {
      "main": {
        "type": "query",
        "description": "Find actor suggestions for a prefix search term. Expected use is for auto-completion during text field entry.",
        "parameters": {
          "type": "params",
          "properties": {
            "q": {
              "type": "string",
              "description": "Search query prefix; not a full query string."
            },
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 10
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "actors"
            ],
            "properties": {
              "actors": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "#actor"
                }
              }
            }
          }
        }
      },
      "actor": {
        "type": "object",
        "required": [
          "did",
          "handle"
        ],
        "properties": {
          "did": {
            "type": "string",
            "format": "did",
            "description": "The actor's DID"
          },
          "handle": {
            "type": "string",
            "format": "handle",
            "description": "The actor's handle"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.startLivestream",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create a new place.stream.livestream record, automatically populating a thumbnail and creating a Bluesky post and whatnot. You can do this manually by creating a record but this method can work better for mobile livestreaming and such.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "livestream"
            ],
            "properties": {
              "livestream": {
                "type": "ref",
                "ref": "place.stream.livestream"
              },
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "createBlueskyPost": {
                "type": "boolean",
                "description": "Whether to create a Bluesky post announcing the livestream."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "uri",
                "description": "The URI of the livestream record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "The CID of the livestream record."
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.stopLivestream",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Stop your current livestream, updating your current place.stream.livestream record and ceasing the flow of video.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [],
            "properties": {}
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "uri",
                "description": "The URI of the stopped livestream record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "The new CID of the stopped livestream record."
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.subscribeSegments",
    "defs": {
      "main": {
        "type": "subscription",
        "description": "Subscribe to a stream's new segments as they come in!",
        "parameters": {
          "type": "params",
          "required": [
            "streamer"
          ],
          "properties": {
            "streamer": {
              "type": "string",
              "description": "The DID of the streamer to subscribe to"
            }
          }
        },
        "message": {
          "schema": {
            "type": "union",
            "refs": [
              "#segment"
            ]
          }
        },
        "errors": []
      },
      "segment": {
        "type": "bytes",
        "description": "MP4 file of a user's signed livestream segment"
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.teleport",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Record defining a 'teleport', that is active during a certain time.",
        "record": {
          "type": "object",
          "required": [
            "streamer",
            "startsAt"
          ],
          "properties": {
            "streamer": {
              "type": "string",
              "format": "did",
              "description": "The DID of the streamer to teleport to."
            },
            "startsAt": {
              "type": "string",
              "format": "datetime",
              "description": "The time the teleport becomes active."
            },
            "livestream": {
              "type": "ref",
              "ref": "com.atproto.repo.strongRef",
              "description": "The source livestream this teleport is sending viewers away from. When the teleport fires, this is the livestream that gets ended (the same update place.stream.live.stopLivestream performs), so the source streamer returns to pre-live. Teleports without an origin livestream are treated as a no-op."
            },
            "durationSeconds": {
              "type": "integer",
              "description": "The time limit in seconds for the teleport. If not set, the teleport is permanent. Must be at least 60 seconds, and no more than 32,400 seconds (9 hours).",
              "minimum": 60,
              "maximum": 32400
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.live.viewerCount",
    "defs": {
      "main": {
        "type": "record",
        "key": "any",
        "description": "Current viewer count for a livestream on a particular server. Record keys are streamer_did::server_did by convention.",
        "record": {
          "type": "object",
          "required": [
            "streamer",
            "server",
            "count"
          ],
          "properties": {
            "streamer": {
              "type": "string",
              "format": "did",
              "description": "The DID of the streamer to teleport to."
            },
            "server": {
              "type": "string",
              "format": "did",
              "description": "The DID of the server to get the view count for."
            },
            "count": {
              "type": "integer",
              "description": "The current view count for the livestream."
            },
            "updatedAt": {
              "type": "string",
              "format": "datetime",
              "description": "The time the view count was last updated."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.livestream",
    "defs": {
      "main": {
        "type": "record",
        "description": "Record announcing a livestream is happening",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "title",
            "createdAt"
          ],
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 1400,
              "maxGraphemes": 140,
              "description": "The title of the livestream, as it will be announced to followers."
            },
            "url": {
              "type": "string",
              "format": "uri",
              "description": "The URL where this stream can be found. This is primarily a hint for other Streamplace nodes to locate and replicate the stream."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this livestream started."
            },
            "lastSeenAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this livestream was last seen by the Streamplace station."
            },
            "endedAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this livestream ended. Ended livestreams are not supposed to start up again."
            },
            "idleTimeoutSeconds": {
              "type": "integer",
              "description": "Time in seconds after which this livestream should be automatically ended if idle. Zero means no timeout."
            },
            "post": {
              "type": "ref",
              "ref": "com.atproto.repo.strongRef",
              "description": "The post that announced this livestream."
            },
            "agent": {
              "type": "string",
              "description": "The source of the livestream, if available, in a User Agent format: `<product> / <product-version> <comment>` e.g. Streamplace/0.7.5 iOS"
            },
            "canonicalUrl": {
              "type": "string",
              "format": "uri",
              "description": "The primary URL where this livestream can be viewed, if available."
            },
            "thumb": {
              "type": "blob",
              "accept": [
                "image/*"
              ],
              "maxSize": 1000000
            },
            "notificationSettings": {
              "type": "ref",
              "ref": "place.stream.livestream#notificationSettings"
            },
            "activity": {
              "type": "union",
              "description": "The game or activity being streamed.",
              "refs": [
                "place.stream.defs#activityGame",
                "place.stream.defs#activityLabel"
              ]
            },
            "tags": {
              "type": "array",
              "description": "Freeform tags for this stream. Each tag must be alphanumeric (a-z, A-Z, 0-9) plus colon. Tags with colons indicate a specific tag group (e.g. 'lang:en' indicates the stream's primary language).",
              "maxLength": 10,
              "items": {
                "type": "string",
                "maxLength": 640,
                "maxGraphemes": 64
              }
            }
          }
        }
      },
      "notificationSettings": {
        "type": "object",
        "required": [],
        "properties": {
          "pushNotification": {
            "type": "boolean",
            "description": "Whether this livestream should trigger a push notification to followers."
          }
        }
      },
      "livestreamView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record",
          "indexedAt"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          },
          "indexedAt": {
            "type": "string",
            "format": "datetime"
          },
          "viewerCount": {
            "type": "ref",
            "description": "The number of viewers watching this livestream. Use when you can't reasonably use #viewerCount directly.",
            "ref": "#viewerCount"
          }
        }
      },
      "viewerCount": {
        "type": "object",
        "required": [
          "count"
        ],
        "properties": {
          "count": {
            "type": "integer",
            "description": "Viewers watching right now."
          },
          "total": {
            "type": "integer",
            "description": "Running number of playback sessions this livestream has had (cumulative, session-based; the X-style 'views' beside the concurrent count)."
          }
        }
      },
      "teleportArrival": {
        "type": "object",
        "required": [
          "teleportUri",
          "source",
          "viewerCount",
          "startsAt"
        ],
        "properties": {
          "teleportUri": {
            "type": "string",
            "format": "at-uri",
            "description": "The URI of the teleport record"
          },
          "source": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic",
            "description": "The streamer who is teleporting their viewers here"
          },
          "chatProfile": {
            "type": "ref",
            "ref": "place.stream.chat.profile",
            "description": "The chat profile of the source streamer"
          },
          "viewerCount": {
            "type": "integer",
            "description": "How many viewers are arriving from this teleport"
          },
          "startsAt": {
            "type": "string",
            "format": "datetime",
            "description": "When this teleport started"
          }
        }
      },
      "teleportCanceled": {
        "type": "object",
        "required": [
          "teleportUri",
          "reason"
        ],
        "properties": {
          "teleportUri": {
            "type": "string",
            "format": "at-uri",
            "description": "The URI of the teleport record that was canceled"
          },
          "reason": {
            "type": "string",
            "enum": [
              "deleted",
              "denied",
              "expired"
            ],
            "description": "Why this teleport was canceled"
          }
        }
      },
      "streamplaceAnything": {
        "type": "object",
        "required": [
          "livestream"
        ],
        "properties": {
          "livestream": {
            "type": "union",
            "refs": [
              "#livestreamView",
              "#viewerCount",
              "#teleportArrival",
              "#teleportCanceled",
              "place.stream.defs#blockView",
              "place.stream.defs#renditions",
              "place.stream.defs#rendition",
              "place.stream.chat.defs#messageView",
              "place.stream.chat.defs#pinnedRecordView"
            ]
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.createUpload",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Start a resumable upload of arbitrary media content. Returns a TUS upload URL and a short-lived bearer token used to authenticate subsequent chunk requests (no DPoP required on chunks). The DID of the authenticated user is recorded against the upload; on completion a VOD processing task is enqueued.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "size",
              "mimeType"
            ],
            "properties": {
              "size": {
                "type": "integer",
                "description": "Total size of the upload in bytes."
              },
              "mimeType": {
                "type": "string",
                "description": "MIME type of the content being uploaded (e.g. video/mp4)."
              },
              "filename": {
                "type": "string",
                "description": "Optional filename hint to attach as upload metadata."
              },
              "draftUri": {
                "type": "string",
                "description": "Optional ats:// URI of a draft VOD created via place.stream.vod.createDraft. When supplied, the upload's processing fills that draft (rather than creating a new one), so the user can edit metadata while the upload runs and re-upload if it fails. The draft's origin_upload_id is set to this upload."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uploadUrl",
              "uploadToken",
              "expiresAt",
              "uploadId"
            ],
            "properties": {
              "uploadId": {
                "type": "string",
                "description": "Server-side identifier for this upload."
              },
              "uploadUrl": {
                "type": "string",
                "format": "uri",
                "description": "Absolute URL to PATCH/HEAD per the TUS protocol."
              },
              "uploadToken": {
                "type": "string",
                "description": "Short-lived bearer token bound to this upload. Send as 'Authorization: Bearer <token>' on TUS requests."
              },
              "expiresAt": {
                "type": "string",
                "format": "datetime",
                "description": "When the upload token expires."
              }
            }
          }
        },
        "errors": [
          {
            "name": "UploadTooLarge",
            "description": "The requested upload exceeds the server's maximum allowed size."
          },
          {
            "name": "UnsupportedMimeType",
            "description": "The server does not accept this MIME type for upload."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.defs",
    "defs": {
      "sourceTracks": {
        "type": "object",
        "description": "A collection of tracks representing the canonical source of a video.",
        "required": [
          "tracks"
        ],
        "properties": {
          "tracks": {
            "type": "array",
            "description": "The canonical list of tracks specifying the source of a video.",
            "items": {
              "type": "ref",
              "ref": "com.atproto.repo.strongRef"
            }
          }
        }
      },
      "sourceClip": {
        "type": "object",
        "description": "An object representing that this video's source is a clip from another video.",
        "required": [
          "video",
          "start",
          "end"
        ],
        "properties": {
          "video": {
            "type": "string",
            "format": "at-uri",
            "description": "AT URI of the video we're clipping."
          },
          "start": {
            "type": "integer",
            "description": "Start time of the clip in milliseconds."
          },
          "end": {
            "type": "integer",
            "description": "End time of the clip in milliseconds."
          }
        }
      },
      "muxlTrack": {
        "type": "object",
        "description": "A track backed by a MUXL container",
        "required": [
          "blob",
          "trackId",
          "mediaType"
        ],
        "properties": {
          "blob": {
            "type": "string",
            "description": "BLAKE-3 content hash (BDASL CID) of the source video segment."
          },
          "size": {
            "type": "integer",
            "description": "Size in bytes of the source video segment."
          },
          "trackId": {
            "type": "string",
            "description": "ID of the track within the MUXL container. 1-indexed for MP4 reasons."
          },
          "mediaType": {
            "type": "string",
            "description": "Type of the track: video, audio, or text."
          },
          "language": {
            "type": "string",
            "description": "Language of the track, if applicable."
          },
          "signingKey": {
            "type": "string",
            "format": "did",
            "description": "did:key of the ephemeral key that C2PA-signed this track's segments. The private key is discarded once the track is produced, so it can only ever have signed this content."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.finalizeLivestream",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Turn a finished livestream into a VOD. The server concatenates the MUXL segments it recorded for the livestream into a single content blob, derives the playback sidecars, and publishes the place.stream.media.track records. Processing completes server-side and creates a draft VOD; the client does not need to poll or publish — the user publishes the draft later via place.stream.vod.publishDraft. Returns the draft's ats:// URI so the client can navigate to it, alongside an uploadId for backwards compatibility.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "livestream"
            ],
            "properties": {
              "livestream": {
                "type": "string",
                "format": "at-uri",
                "description": "AT-URI of the place.stream.livestream record to finalize into a VOD. Must belong to the authenticated user."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uploadId",
              "draftUri"
            ],
            "properties": {
              "uploadId": {
                "type": "string",
                "description": "Identifier for the finalize job. Retained for backwards compatibility; the draft flow no longer requires the client to poll getUploadStatus."
              },
              "draftUri": {
                "type": "string",
                "description": "The ats:// URI of the draft VOD created for this finalize. The draft reaches status 'ready' when processing completes; the user publishes it from the Drafts tab via place.stream.vod.publishDraft."
              }
            }
          }
        },
        "errors": [
          {
            "name": "LivestreamNotFound",
            "description": "No livestream with the given URI is known, or it does not belong to the authenticated user."
          },
          {
            "name": "NoRecording",
            "description": "The livestream has no recorded MUXL segments to finalize (recording was not enabled, or none completed)."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.getUploadStatus",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get the processing status of a previously created upload. Only accessible by the DID that created the upload.",
        "parameters": {
          "type": "params",
          "required": [
            "uploadId"
          ],
          "properties": {
            "uploadId": {
              "type": "string",
              "description": "The upload ID returned by place.stream.media.createUpload."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "status"
            ],
            "properties": {
              "status": {
                "type": "string",
                "knownValues": [
                  "pending",
                  "processing",
                  "done",
                  "error"
                ],
                "description": "Current processing status of the upload."
              },
              "progress": {
                "type": "integer",
                "minimum": 0,
                "maximum": 100,
                "description": "Processing progress percentage (0-100). Only meaningful when status is 'processing'."
              },
              "tracks": {
                "type": "array",
                "description": "Published track records. Present when status is 'done'.",
                "items": {
                  "type": "ref",
                  "ref": "#trackRef"
                }
              },
              "durationMs": {
                "type": "integer",
                "description": "Duration of the processed video in milliseconds. Present when status is 'done'."
              },
              "error": {
                "type": "string",
                "description": "Error message. Present when status is 'error'."
              }
            }
          }
        },
        "errors": [
          {
            "name": "NotFound",
            "description": "No upload exists with the given ID for the authenticated user."
          }
        ]
      },
      "trackRef": {
        "type": "object",
        "required": [
          "uri",
          "cid"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.getVideo",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get a hydrated view of a place.stream.video record — the record itself plus author info plus aggregated view counts summed across every reporting node we've indexed. View counts come from place.stream.media.viewCount records; consumers see one number per metric, with the underlying multi-reporter detail collapsed away.",
        "parameters": {
          "type": "params",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the place.stream.video record."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "ref",
            "ref": "#videoView"
          }
        },
        "errors": [
          {
            "name": "VideoNotFound",
            "description": "No record indexed at the supplied AT-URI."
          }
        ]
      },
      "videoView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record",
          "viewCounts",
          "likeCount"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          },
          "likeCount": {
            "type": "integer",
            "minimum": 0,
            "description": "Total number of place.stream.like records whose subject is this video. Always present; zero when none, so consumers can render a count unconditionally."
          },
          "viewCounts": {
            "type": "ref",
            "ref": "#viewCountSummary",
            "description": "Aggregated view counts across every indexed reporter. Always present; zero-valued (count=0, reporters=0) when no place.stream.media.viewCount records have been observed yet, so consumers can render a count unconditionally."
          },
          "tracks": {
            "type": "array",
            "items": {
              "type": "ref",
              "ref": "place.stream.media.track#trackView"
            }
          }
        }
      },
      "viewCountSummary": {
        "type": "object",
        "description": "Sums across every place.stream.media.viewCount record indexed for this video, regardless of reporter or window. The underlying records are window-bounded; the consumer sees a running total.",
        "required": [
          "count",
          "bytes",
          "durationMs",
          "reporters"
        ],
        "properties": {
          "count": {
            "type": "integer",
            "minimum": 0,
            "description": "Sum of `count` across every indexed report."
          },
          "bytes": {
            "type": "integer",
            "minimum": 0,
            "description": "Sum of bytes transferred across every track row in every indexed report."
          },
          "durationMs": {
            "type": "integer",
            "minimum": 0,
            "description": "Sum of playback duration (ms) across every track row in every indexed report."
          },
          "reporters": {
            "type": "integer",
            "minimum": 0,
            "description": "Number of distinct streamplace nodes that have contributed at least one viewCount record for this video."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.getVideoList",
    "defs": {
      "main": {
        "type": "query",
        "description": "List videos newest first. Scoped to a single repo when `repo` is supplied; otherwise lists videos across every indexed repo. Returns hydrated video views with author info and view counts.",
        "parameters": {
          "type": "params",
          "required": [],
          "properties": {
            "repo": {
              "type": "string",
              "description": "DID or handle of the repo whose videos to list. Omit to list videos globally across all repos."
            },
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 25,
              "description": "Maximum number of videos to return."
            },
            "cursor": {
              "type": "string",
              "description": "Pagination cursor from a previous response."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "videos"
            ],
            "properties": {
              "videos": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.media.getVideo#videoView"
                }
              },
              "cursor": {
                "type": "string",
                "description": "Pagination cursor for the next page, if any."
              }
            }
          }
        },
        "errors": [
          {
            "name": "RepoNotFound",
            "description": "No repo indexed at the supplied DID."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.origin",
    "defs": {
      "main": {
        "type": "record",
        "description": "An attestation that a MUXL blob is available for download from the publishing node, retrievable via XRPC (com.atproto.repo.getBlob and similar). Published by the Streamplace node that hosts the blob, not by the user who owns the underlying video. The rkey is conventionally the blob's BDASL CID — atproto lexicon doesn't yet have a literal-rkey syntax so we settle for `key: any` and rely on the convention.",
        "key": "any",
        "record": {
          "type": "object",
          "required": [
            "blob",
            "size",
            "mimeType"
          ],
          "properties": {
            "blob": {
              "type": "string",
              "description": "BLAKE-3 content hash (BDASL CID) of the blob."
            },
            "size": {
              "type": "integer",
              "description": "Size of the blob in bytes."
            },
            "mimeType": {
              "type": "string",
              "description": "MIME type of the blob (e.g. video/mp4)."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.publishVideo",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Publish a place.stream.video record for a finished upload, server-side. The caller supplies the record it would otherwise putRecord itself; the server overrides the fields it is authoritative about (source tracks and durationMs, taken from the processed upload) and, if the record carries no thumb, generates one from the video and attaches it. The record is written to the authenticated user's repo.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uploadId",
              "record"
            ],
            "properties": {
              "uploadId": {
                "type": "string",
                "description": "The upload ID returned by place.stream.media.createUpload. Its processing must be complete (status 'done')."
              },
              "record": {
                "type": "ref",
                "ref": "place.stream.video",
                "description": "A place.stream.video record. The server overrides `source` and `durationMs` from the processed upload, and fills in `thumb` with a generated thumbnail when the supplied record has none."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri",
                "description": "AT-URI of the created place.stream.video record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "CID of the created place.stream.video record."
              }
            }
          }
        },
        "errors": [
          {
            "name": "UploadNotFound",
            "description": "No upload with the given ID belongs to the authenticated user."
          },
          {
            "name": "UploadNotReady",
            "description": "The upload has not finished processing, so its tracks aren't available yet."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.track",
    "defs": {
      "main": {
        "type": "record",
        "description": "A track for a video stream, either part of the source or a custom additional track. One of: video, audio, subtitles.",
        "key": "tid",
        "record": {
          "required": [
            "track"
          ],
          "type": "object",
          "properties": {
            "track": {
              "type": "union",
              "refs": [
                "place.stream.media.defs#muxlTrack"
              ]
            },
            "video": {
              "type": "string",
              "format": "at-uri",
              "description": "If this is a derived track like a transcode or a transcript, what was the source place.stream.video?"
            },
            "parentTrack": {
              "type": "ref",
              "ref": "com.atproto.repo.strongRef",
              "description": "If this is a derived track like a transcode or a transcript, what was the parent track?"
            },
            "metadata": {
              "type": "union",
              "refs": [
                "place.stream.media.track#commonMetadata"
              ]
            }
          }
        }
      },
      "commonMetadata": {
        "type": "object",
        "description": "Metadata common to all media types. Contains subobjects for other media types.",
        "required": [],
        "properties": {
          "language": {
            "type": "string",
            "description": "IETF BCP 47 language tag corresponding to the content of this track"
          },
          "durationMs": {
            "type": "integer",
            "description": "duration of this track in milliseconds"
          },
          "video": {
            "type": "ref",
            "ref": "place.stream.segment#video"
          },
          "audio": {
            "type": "ref",
            "ref": "place.stream.segment#audio"
          }
        }
      },
      "trackView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.media.viewCount",
    "defs": {
      "main": {
        "type": "record",
        "description": "A streamplace node's report of view counts for one place.stream.video over a closed time window. Published in the reporting node's server repo (not the streamer's), so a video served by multiple nodes accumulates multiple records — consumers are expected to sum across trusted reporters. The rkey is conventionally `<windowStart-as-tid>-<video-rkey>` so re-running the aggregator over the same window is idempotent. Counts represent the reporting node's best effort given the data it has; the `tracks` array carries the objective byte / duration totals it observed.",
        "key": "any",
        "record": {
          "type": "object",
          "required": [
            "video",
            "count",
            "windowStart",
            "windowEnd",
            "indexedAt"
          ],
          "properties": {
            "video": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the place.stream.video this count is for."
            },
            "count": {
              "type": "integer",
              "minimum": 0,
              "description": "Number of distinct sessions the reporting node observed as a view over [windowStart, windowEnd)."
            },
            "windowStart": {
              "type": "string",
              "format": "datetime",
              "description": "Inclusive lower bound of the aggregation window."
            },
            "windowEnd": {
              "type": "string",
              "format": "datetime",
              "description": "Exclusive upper bound of the aggregation window."
            },
            "tracks": {
              "type": "array",
              "description": "Per-track totals of bytes + playback duration the reporting node served over the window. Each entry references the place.stream.media.track record whose bytes were transferred, so user-contributed tracks (transcripts, transcodes published by other accounts) attribute naturally to their own records.",
              "items": {
                "type": "ref",
                "ref": "#trackUsage"
              }
            },
            "indexedAt": {
              "type": "string",
              "format": "datetime",
              "description": "When the reporting node ran this aggregation. Useful for ordering successive reports."
            }
          }
        }
      },
      "trackUsage": {
        "type": "object",
        "description": "One row of the tracks array: bytes + duration transferred for a single place.stream.media.track record over the window.",
        "required": [
          "track",
          "bytes",
          "durationMs"
        ],
        "properties": {
          "track": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef",
            "description": "Strong reference to the place.stream.media.track record whose bytes were transferred."
          },
          "bytes": {
            "type": "integer",
            "minimum": 0,
            "description": "Total bytes served from this track over the window. Sum across attributed segment_requests' Range intersections with the track's segment offsets in the metafile."
          },
          "durationMs": {
            "type": "integer",
            "minimum": 0,
            "description": "Total playback duration served from this track, in milliseconds. Per HLS segment in the range: (overlap bytes / segment bytes) * segment duration, so partial-segment fetches credit a proportional share of duration."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.metadata.configuration",
    "defs": {
      "main": {
        "type": "record",
        "description": "Default metadata record for livestream including content warnings, rights, and distribution policy",
        "key": "literal:self",
        "record": {
          "type": "object",
          "properties": {
            "contentWarnings": {
              "type": "ref",
              "ref": "place.stream.metadata.contentWarnings"
            },
            "contentRights": {
              "type": "ref",
              "ref": "place.stream.metadata.contentRights"
            },
            "distributionPolicy": {
              "type": "ref",
              "ref": "place.stream.metadata.distributionPolicy"
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.metadata.contentRights",
    "defs": {
      "main": {
        "type": "object",
        "description": "Content rights and attribution information.",
        "properties": {
          "creator": {
            "type": "string",
            "description": "Name of the creator of the work."
          },
          "copyrightNotice": {
            "type": "string",
            "description": "Copyright notice for the work."
          },
          "copyrightYear": {
            "type": "integer",
            "description": "Year of creation or publication."
          },
          "license": {
            "type": "string",
            "description": "License URL or identifier.",
            "knownValues": [
              "place.stream.metadata.contentRights#all-rights-reserved",
              "place.stream.metadata.contentRights#cc0_1__0",
              "place.stream.metadata.contentRights#cc-by_4__0",
              "place.stream.metadata.contentRights#cc-by-sa_4__0",
              "place.stream.metadata.contentRights#cc-by-nc_4__0",
              "place.stream.metadata.contentRights#cc-by-nc-sa_4__0",
              "place.stream.metadata.contentRights#cc-by-nd_4__0",
              "place.stream.metadata.contentRights#cc-by-nc-nd_4__0"
            ]
          },
          "creditLine": {
            "type": "string",
            "description": "Credit line for the work."
          }
        }
      },
      "all-rights-reserved": {
        "type": "token",
        "description": "All rights reserved to the creator — others cannot use, modify, or share without explicit authorization."
      },
      "cc0_1__0": {
        "type": "token",
        "description": "Public domain dedication. You waive all copyright and related rights where possible. Others may copy, modify, distribute, or perform your work for any purpose without attribution."
      },
      "cc-by_4__0": {
        "type": "token",
        "description": "Attribution required. Others may copy, distribute, remix, and build upon your work, even commercially, if they credit you."
      },
      "cc-by-sa_4__0": {
        "type": "token",
        "description": "Attribution + share-alike. Others may adapt and build upon your work, even commercially, if they credit you and license their new creations under identical terms."
      },
      "cc-by-nc_4__0": {
        "type": "token",
        "description": "Attribution + non-commercial. Others may adapt and build upon your work for non-commercial purposes only, and must credit you."
      },
      "cc-by-nc-sa_4__0": {
        "type": "token",
        "description": "Attribution + non-commercial + share-alike. Others may adapt and build upon your work for non-commercial purposes only, must credit you, and must license their new creations under identical terms."
      },
      "cc-by-nd_4__0": {
        "type": "token",
        "description": "Attribution + no derivatives. Others may reuse your work, even commercially, but it must remain unchanged and you must be credited."
      },
      "cc-by-nc-nd_4__0": {
        "type": "token",
        "description": "Attribution + non-commercial + no derivatives. Others may download and share your work with credit, but cannot change it or use it commercially."
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.metadata.contentWarnings",
    "defs": {
      "main": {
        "type": "object",
        "description": "Content warnings for a stream.",
        "properties": {
          "warnings": {
            "type": "array",
            "items": {
              "type": "string",
              "knownValues": [
                "place.stream.metadata.contentWarnings#death",
                "place.stream.metadata.contentWarnings#drugUse",
                "place.stream.metadata.contentWarnings#fantasyViolence",
                "place.stream.metadata.contentWarnings#flashingLights",
                "place.stream.metadata.contentWarnings#language",
                "place.stream.metadata.contentWarnings#nudity",
                "place.stream.metadata.contentWarnings#PII",
                "place.stream.metadata.contentWarnings#sexuality",
                "place.stream.metadata.contentWarnings#suffering",
                "place.stream.metadata.contentWarnings#violence"
              ]
            }
          }
        }
      },
      "death": {
        "type": "token",
        "description": "The content could be perceived as offensive due to the discussion or display of death."
      },
      "drugUse": {
        "type": "token",
        "description": "The content contains a portrayal of the use or abuse of mind altering substances."
      },
      "fantasyViolence": {
        "type": "token",
        "description": "The content contains violent actions of a fantasy nature, involving human or non-human characters in situations easily distinguishable from real life."
      },
      "flashingLights": {
        "type": "token",
        "description": "The content contains flashing lights that could be harmful to viewers with seizure disorders such as photosensitive epilepsy."
      },
      "language": {
        "type": "token",
        "description": "The content could be perceived as offensive due to the language used."
      },
      "nudity": {
        "type": "token",
        "description": "The content could be perceived as offensive due to nudity."
      },
      "PII": {
        "type": "token",
        "description": "The content contains information that can be used to identify a particular individual, such as a name, phone number, email address, physical address, or IP address."
      },
      "sexuality": {
        "type": "token",
        "description": "The content could be perceived as offensive due to the discussion or display of sexuality."
      },
      "suffering": {
        "type": "token",
        "description": "The content could be perceived as distressing due to the discussion or display of suffering or triggering topics, including suicide, eating disorders or self harm."
      },
      "violence": {
        "type": "token",
        "description": "The content could be perceived as offensive due to the discussion or display of violence."
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.metadata.distributionPolicy",
    "defs": {
      "main": {
        "type": "object",
        "description": "Distribution and rebroadcast policy.",
        "properties": {
          "deleteAfter": {
            "type": "integer",
            "description": "Duration in seconds after which segments should be deleted. Each segment will expire N seconds after its creation time. -1 to allow indefinite archival."
          },
          "allowedBroadcasters": {
            "type": "array",
            "description": "List of did:webs of the broadcasters you want to allow to distribute your content. \"*\" allows anyone. Starting a line with a \"!\" bans that broadcaster.",
            "items": {
              "type": "string"
            }
          },
          "allowGenAiTraining": {
            "type": "boolean",
            "description": "Whether this content may be used as training data for generative AI models. Absent means undeclared; Streamplace treats undeclared as false and stamps an explicit value into every minted segment. Covers generative AI only — non-generative machine learning (e.g. moderation, accessibility, speech models) is not governed by this flag."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.createBlock",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create a block (ban) on behalf of a streamer. Requires 'ban' permission. Creates an app.bsky.graph.block record in the streamer's repository.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "subject"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer whose chat this block applies to."
              },
              "subject": {
                "type": "string",
                "format": "did",
                "description": "The DID of the user being blocked from chat."
              },
              "reason": {
                "type": "string",
                "maxLength": 300,
                "description": "Optional reason for the block."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the created block record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "The CID of the created block record."
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to create blocks for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.createGate",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create a gate (hide message) on behalf of a streamer. Requires 'hide' permission. Creates a place.stream.chat.gate record in the streamer's repository.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "messageUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "messageUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the chat message to hide."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the created gate record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "The CID of the created gate record."
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to hide messages for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.createPin",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Pin a chat message on behalf of a streamer. Requires 'message.pin' permission. Creates a place.stream.chat.pinnedRecord in the streamer's repo, replacing any existing pin.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "messageUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "messageUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the chat message to pin."
              },
              "expiresAt": {
                "type": "string",
                "format": "datetime",
                "description": "Optional expiration time for this pin."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the created pinned record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "The CID of the created pinned record."
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to pin messages for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.createVodGate",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create a gate (hide VOD comment) on behalf of a streamer. Requires 'vod.comment.hide' permission. Creates a place.stream.vod.gate record in the streamer's repository.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "commentUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "commentUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the VOD comment to hide."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the created gate record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "The CID of the created gate record."
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to hide VOD comments for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.defs",
    "defs": {
      "permissionView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri",
            "description": "AT-URI of the permission record"
          },
          "cid": {
            "type": "string",
            "format": "cid",
            "description": "Content identifier of the permission record"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic",
            "description": "The streamer who granted these permissions"
          },
          "record": {
            "type": "unknown",
            "description": "The permission record itself"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.deleteBlock",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Delete a block (unban) on behalf of a streamer. Requires 'ban' permission. Deletes an app.bsky.graph.block record from the streamer's repository.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "blockUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "blockUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the block record to delete."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {}
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to delete blocks for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.deleteGate",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Delete a gate (unhide message) on behalf of a streamer. Requires 'hide' permission. Deletes a place.stream.chat.gate record from the streamer's repository.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "gateUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "gateUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the gate record to delete."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {}
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to unhide messages for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.deletePin",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Unpin a pinned chat message on behalf of a streamer. Requires 'message.pin' permission. Deletes the place.stream.chat.pinnedRecord from the streamer's repo.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "pinUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "pinUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the pinned record to delete."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {}
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to unpin messages for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.deleteVodGate",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Delete a gate (unhide VOD comment) on behalf of a streamer. Requires 'vod.comment.hide' permission. Deletes a place.stream.vod.gate record from the streamer's repository.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "gateUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "gateUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the gate record to delete."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {}
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to unhide VOD comments for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.permission",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Record granting moderation permissions to a user for this streamer's content.",
        "record": {
          "type": "object",
          "required": [
            "moderator",
            "permissions",
            "createdAt"
          ],
          "properties": {
            "moderator": {
              "type": "string",
              "format": "did",
              "description": "The DID of the user granted moderator permissions."
            },
            "permissions": {
              "type": "array",
              "items": {
                "type": "string",
                "enum": [
                  "ban",
                  "hide",
                  "livestream.manage",
                  "message.pin",
                  "vod.comment.hide"
                ]
              },
              "description": "Array of permissions granted to this moderator. 'ban' covers blocks/bans (with optional expiration), 'hide' covers message gates, 'livestream.manage' allows updating livestream metadata."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this moderator was added."
            },
            "expirationTime": {
              "type": "string",
              "format": "datetime",
              "description": "Optional expiration time for this delegation. If set, the delegation is invalid after this time."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.moderation.updateLivestream",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Update livestream metadata on behalf of a streamer. Requires 'livestream.manage' permission. Updates a place.stream.livestream record in the streamer's repository.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "streamer",
              "livestreamUri"
            ],
            "properties": {
              "streamer": {
                "type": "string",
                "format": "did",
                "description": "The DID of the streamer."
              },
              "livestreamUri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the livestream record to update."
              },
              "title": {
                "type": "string",
                "maxLength": 1400,
                "maxGraphemes": 140,
                "description": "New title for the livestream."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri",
              "cid"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "format": "at-uri",
                "description": "The AT-URI of the updated livestream record."
              },
              "cid": {
                "type": "string",
                "format": "cid",
                "description": "The CID of the updated livestream record."
              }
            }
          }
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "The request lacks valid authentication credentials."
          },
          {
            "name": "Forbidden",
            "description": "The caller does not have permission to update livestream metadata for this streamer."
          },
          {
            "name": "SessionNotFound",
            "description": "The streamer's OAuth session could not be found or is invalid."
          },
          {
            "name": "RecordNotFound",
            "description": "The specified livestream record does not exist."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.multistream.createTarget",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create a new target for rebroadcasting a Streamplace stream.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "multistreamTarget"
            ],
            "properties": {
              "multistreamTarget": {
                "type": "ref",
                "ref": "place.stream.multistream.target"
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "ref",
            "ref": "place.stream.multistream.defs#targetView"
          }
        },
        "errors": [
          {
            "name": "InvalidTargetUrl",
            "description": "The provided target URL is invalid or unreachable."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.multistream.defs",
    "defs": {
      "targetView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "record"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "record": {
            "type": "unknown"
          },
          "latestEvent": {
            "type": "ref",
            "ref": "place.stream.multistream.defs#event"
          }
        }
      },
      "event": {
        "type": "object",
        "required": [
          "message",
          "status",
          "createdAt"
        ],
        "properties": {
          "message": {
            "type": "string"
          },
          "status": {
            "type": "string",
            "enum": [
              "inactive",
              "pending",
              "active",
              "error"
            ]
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.multistream.deleteTarget",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Delete a target for rebroadcasting a Streamplace stream.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "rkey"
            ],
            "properties": {
              "rkey": {
                "type": "string",
                "format": "record-key",
                "description": "The Record Key of the target to delete."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {}
          }
        },
        "errors": []
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.multistream.listTargets",
    "defs": {
      "main": {
        "type": "query",
        "description": "List a range of targets for rebroadcasting a Streamplace stream.",
        "parameters": {
          "type": "params",
          "required": [],
          "properties": {
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 50,
              "description": "The number of targets to return."
            },
            "cursor": {
              "type": "string"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "targets"
            ],
            "properties": {
              "targets": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.multistream.defs#targetView"
                }
              },
              "cursor": {
                "type": "string"
              }
            }
          }
        }
      },
      "record": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "value"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "value": {
            "type": "unknown"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.multistream.putTarget",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Update an existing target for rebroadcasting a Streamplace stream.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "multistreamTarget"
            ],
            "properties": {
              "multistreamTarget": {
                "type": "ref",
                "ref": "place.stream.multistream.target"
              },
              "rkey": {
                "type": "string",
                "format": "record-key",
                "description": "The Record Key.",
                "maxLength": 512
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "ref",
            "ref": "place.stream.multistream.defs#targetView"
          }
        },
        "errors": [
          {
            "name": "InvalidTargetUrl",
            "description": "The provided target URL is invalid or unreachable."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.multistream.target",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "An external server for rebroadcasting a Streamplace stream",
        "record": {
          "required": [
            "url",
            "active",
            "createdAt"
          ],
          "type": "object",
          "properties": {
            "url": {
              "type": "string",
              "format": "uri",
              "description": "The rtmp:// or rtmps:// url of the target server."
            },
            "active": {
              "type": "boolean",
              "description": "Whether this target is currently active."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "When this target was created."
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "A user-friendly name for this target."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.playback.getLivePlaylist",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get an HLS CMAF playlist for a live stream. Returns a master playlist when `track` is omitted, or a single-track media playlist when `track` is supplied. The playlist references each segment + per-track init segment via getLiveSegment. Segments come from an in-memory sliding window fed as the stream is ingested (or replicated to this node), so a playlist is only available while the stream is live here.",
        "parameters": {
          "type": "params",
          "required": [
            "streamer"
          ],
          "properties": {
            "streamer": {
              "type": "string",
              "description": "The streamer to play back: a DID (did:plc/did:web/did:key) or a Bluesky handle, which is resolved to its DID."
            },
            "track": {
              "type": "string",
              "description": "Track ID (stringified u32 matching the MUXL container) for a single-track media playlist. Omit for the master playlist."
            },
            "sid": {
              "type": "string",
              "description": "Opaque playback session identifier. Omit on the master playlist request; the server generates one and threads it through the sub-playlist + segment URLs it returns, for view-count correlation."
            },
            "token": {
              "type": "string",
              "description": "A playback token from getLiveToken. Lets the streamer watch their own stream before it is published; ignored once the stream is live."
            }
          }
        },
        "output": {
          "encoding": "*/*"
        },
        "errors": [
          {
            "name": "StreamNotLive",
            "description": "No live segments are currently windowed for this streamer on this node."
          },
          {
            "name": "TrackNotFound",
            "description": "The requested track ID is not present in the live stream."
          },
          {
            "name": "StreamUnavailable",
            "description": "The streamer's account is unavailable (e.g. banned)."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.playback.getLiveSegment",
    "defs": {
      "main": {
        "type": "query",
        "description": "Fetch a single live HLS segment, or a track's init segment, from the in-memory live window. `seg` is `init` for the EXT-X-MAP init segment, otherwise the segment's media-sequence number; a cosmetic `.m4s` suffix is accepted (and ignored) so ffmpeg-based HLS players will fetch it. HTTP Range is honored. Segments are the verbatim signed canonical .m4s, so provenance travels with playback.",
        "parameters": {
          "type": "params",
          "required": [
            "streamer",
            "track",
            "seg"
          ],
          "properties": {
            "streamer": {
              "type": "string",
              "description": "The streamer: a DID or a Bluesky handle (resolved to its DID)."
            },
            "track": {
              "type": "string",
              "description": "Track ID (stringified u32 matching the MUXL container)."
            },
            "seg": {
              "type": "string",
              "description": "`init` for the track's init segment, or the segment's media-sequence number. A trailing `.m4s` is accepted and ignored."
            },
            "sid": {
              "type": "string",
              "description": "Opaque playback session identifier, propagated from the media playlist that referenced this segment. Logged for view-count correlation; not used for access control."
            },
            "token": {
              "type": "string",
              "description": "A playback token from getLiveToken. Lets the streamer watch their own stream before it is published; ignored once the stream is live."
            }
          }
        },
        "output": {
          "encoding": "video/mp4"
        },
        "errors": [
          {
            "name": "StreamNotLive",
            "description": "No live window for this streamer on this node."
          },
          {
            "name": "SegmentNotFound",
            "description": "The requested segment has slid out of the window, or never existed."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.playback.getLiveToken",
    "defs": {
      "main": {
        "type": "query",
        "description": "Mint a short-lived playback token for the caller's own live stream, so their player can watch it over HLS before it is published (pre-live). HLS requests carry no session; the token, passed as `token` on getLivePlaylist and getLiveSegment, stands in for one. Requires an authenticated session; the token is bound to the caller's DID.",
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "token",
              "expiresAt"
            ],
            "properties": {
              "token": {
                "type": "string",
                "description": "Opaque token to pass as the `token` query parameter."
              },
              "expiresAt": {
                "type": "string",
                "format": "datetime",
                "description": "When the token stops working; fetch a new one before then."
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.playback.getPlaybackServer",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get available playback servers for a livestream.",
        "parameters": {
          "type": "params",
          "required": [
            "stream"
          ],
          "properties": {
            "stream": {
              "type": "string",
              "description": "Identifier of the stream to get playback servers for"
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "servers"
            ],
            "properties": {
              "servers": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "List of available playback server addresses"
              }
            }
          }
        },
        "errors": []
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.playback.getVideoBlob",
    "defs": {
      "main": {
        "type": "query",
        "description": "Fetch a content-addressed MUXL playback blob by CID. Serves either a primary fMP4 archive or a per-track init segment — both are CID-addressed and indistinguishable from the endpoint's point of view. HTTP `Range` headers are honored; HLS media playlists generated by getVideoPlaylist reference this endpoint with `EXT-X-BYTERANGE` to serve segments out of the primary blob. The `did` identifies the owning account for egress accounting: the blob itself is content-addressed and owner-agnostic, so the caller carries the attribution.",
        "parameters": {
          "type": "params",
          "required": [
            "did",
            "cid"
          ],
          "properties": {
            "did": {
              "type": "string",
              "format": "did",
              "description": "DID of the account that owns the record this blob is being served for. Used for egress/usage accounting, not for access control — the blob is served purely by CID."
            },
            "cid": {
              "type": "string",
              "description": "BLAKE-3 BDASL CID of the requested blob."
            },
            "sid": {
              "type": "string",
              "description": "Opaque playback session identifier, propagated unmodified from the media playlist that referenced this blob. Logged for view-count correlation; not used for access control."
            }
          }
        },
        "output": {
          "encoding": "video/mp4"
        },
        "errors": [
          {
            "name": "BlobNotFound",
            "description": "This node doesn't have the requested CID. The caller should consult place.stream.media.origin records to find a node that does."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.playback.getVideoPlaylist",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get an HLS CMAF playlist for a video. Returns a master playlist when `track` is omitted, or a single-track media playlist when `track` is supplied. The playlist references each segment + per-track init segment via getVideoBlob, addressed by content hash. The `uri` is an AT-URI pointing at a playable record — today only place.stream.video records are supported, but the surface is collection-agnostic so other record types can join later.",
        "parameters": {
          "type": "params",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the record to play back (e.g. at://did:plc:.../place.stream.video/<rkey>)."
            },
            "track": {
              "type": "string",
              "description": "Track ID (stringified u32 matching the MUXL container) for a single-track media playlist. Omit for the master playlist."
            },
            "start": {
              "type": "integer",
              "description": "Start time in milliseconds from the beginning of the video. Defaults to 0. For a place.stream.video record whose source is a place.stream.media.defs#sourceClip, this is in the clip's local timeline (0 == the clip's start)."
            },
            "end": {
              "type": "integer",
              "description": "End time in milliseconds. Omit to include all remaining content. Local to the clip's timeline when playing back a sourceClip record."
            },
            "sid": {
              "type": "string",
              "description": "Opaque playback session identifier. Omit on the master playlist request; the server generates one and embeds it in every sub-playlist URL it returns. Players never have to construct it themselves — they just follow the URLs the master playlist hands them, which carry the sid into media-playlist + segment requests. Used downstream to correlate a player's playlist + segment fetches for view-count accounting."
            }
          }
        },
        "output": {
          "encoding": "*/*"
        },
        "errors": [
          {
            "name": "VideoNotFound",
            "description": "No record indexed at the supplied AT-URI."
          },
          {
            "name": "TrackNotFound",
            "description": "The requested track ID is not present in the video's blob."
          },
          {
            "name": "BlobNotFound",
            "description": "The record references a blob this node hasn't indexed an origin for."
          },
          {
            "name": "UnsupportedCollection",
            "description": "The AT-URI points at a collection this endpoint doesn't know how to play back."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.playback.whep",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Play a stream over WebRTC using WHEP.",
        "parameters": {
          "type": "params",
          "required": [
            "streamer",
            "rendition"
          ],
          "properties": {
            "streamer": {
              "type": "string",
              "description": "The DID of the streamer to play."
            },
            "rendition": {
              "type": "string",
              "description": "The rendition of the stream to play."
            }
          }
        },
        "input": {
          "encoding": "*/*"
        },
        "output": {
          "encoding": "*/*"
        },
        "errors": [
          {
            "name": "Unauthorized",
            "description": "This user may not play this stream."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.richtext.facet",
    "defs": {
      "main": {
        "type": "object",
        "description": "Annotation of a sub-string within rich text in a livestream chat message.",
        "required": [
          "index",
          "features"
        ],
        "properties": {
          "index": {
            "type": "ref",
            "ref": "app.bsky.richtext.facet#byteSlice"
          },
          "features": {
            "type": "array",
            "items": {
              "type": "union",
              "refs": [
                "app.bsky.richtext.facet#mention",
                "app.bsky.richtext.facet#link"
              ]
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.richtext.videoFacet",
    "defs": {
      "main": {
        "type": "object",
        "description": "Annotation of a sub-string within rich text in a VOD description or comment.",
        "required": [
          "index",
          "features"
        ],
        "properties": {
          "index": {
            "type": "ref",
            "ref": "app.bsky.richtext.facet#byteSlice"
          },
          "features": {
            "type": "array",
            "items": {
              "type": "union",
              "refs": [
                "app.bsky.richtext.facet#mention",
                "app.bsky.richtext.facet#link"
              ]
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.segment",
    "defs": {
      "main": {
        "type": "record",
        "description": "Media file representing a segment of a livestream",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "id",
            "signingKey",
            "startTime",
            "creator"
          ],
          "properties": {
            "id": {
              "type": "string",
              "description": "Unique identifier for the segment"
            },
            "signingKey": {
              "type": "string",
              "description": "The DID of the signing key used for this segment"
            },
            "startTime": {
              "type": "string",
              "format": "datetime",
              "description": "When this segment started"
            },
            "duration": {
              "type": "integer",
              "description": "The duration of the segment in nanoseconds"
            },
            "creator": {
              "type": "string",
              "format": "did"
            },
            "video": {
              "type": "array",
              "items": {
                "type": "ref",
                "ref": "#video"
              }
            },
            "audio": {
              "type": "array",
              "items": {
                "type": "ref",
                "ref": "#audio"
              }
            },
            "size": {
              "type": "integer",
              "description": "The size of the segment in bytes"
            },
            "contentWarnings": {
              "type": "ref",
              "ref": "place.stream.metadata.contentWarnings"
            },
            "contentRights": {
              "type": "ref",
              "ref": "place.stream.metadata.contentRights"
            },
            "distributionPolicy": {
              "type": "ref",
              "ref": "place.stream.metadata.distributionPolicy"
            }
          }
        }
      },
      "audio": {
        "type": "object",
        "required": [
          "codec",
          "rate",
          "channels"
        ],
        "properties": {
          "codec": {
            "type": "string",
            "enum": [
              "opus",
              "aac"
            ]
          },
          "rate": {
            "type": "integer"
          },
          "channels": {
            "type": "integer"
          }
        }
      },
      "video": {
        "type": "object",
        "required": [
          "codec",
          "width",
          "height"
        ],
        "properties": {
          "codec": {
            "type": "string",
            "enum": [
              "h264"
            ]
          },
          "width": {
            "type": "integer"
          },
          "height": {
            "type": "integer"
          },
          "framerate": {
            "type": "ref",
            "ref": "#framerate"
          },
          "bframes": {
            "type": "boolean"
          }
        }
      },
      "framerate": {
        "type": "object",
        "required": [
          "num",
          "den"
        ],
        "properties": {
          "num": {
            "type": "integer"
          },
          "den": {
            "type": "integer"
          }
        }
      },
      "segmentView": {
        "type": "object",
        "required": [
          "cid",
          "record"
        ],
        "properties": {
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "record": {
            "type": "unknown"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.createWebhook",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create a new webhook for receiving Streamplace events.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "url",
              "events"
            ],
            "properties": {
              "url": {
                "type": "string",
                "format": "uri",
                "description": "The webhook URL where events will be sent."
              },
              "events": {
                "type": "array",
                "items": {
                  "type": "string",
                  "enum": [
                    "chat",
                    "livestream",
                    "follow",
                    "mention",
                    "stream.received"
                  ]
                },
                "description": "The types of events this webhook should receive."
              },
              "active": {
                "type": "boolean",
                "default": false,
                "description": "Whether this webhook should be active upon creation."
              },
              "prefix": {
                "type": "string",
                "maxLength": 100,
                "description": "Text to prepend to webhook messages."
              },
              "suffix": {
                "type": "string",
                "maxLength": 100,
                "description": "Text to append to webhook messages."
              },
              "rewrite": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.server.defs#rewriteRule"
                },
                "description": "Text replacement rules for webhook messages."
              },
              "name": {
                "type": "string",
                "maxLength": 100,
                "description": "A user-friendly name for this webhook."
              },
              "description": {
                "type": "string",
                "maxLength": 500,
                "description": "A description of what this webhook is used for."
              },
              "muteWords": {
                "type": "array",
                "items": {
                  "type": "string",
                  "maxLength": 100
                },
                "description": "Words to filter out from chat messages. Messages containing any of these words will not be forwarded."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "webhook"
            ],
            "properties": {
              "webhook": {
                "type": "ref",
                "ref": "place.stream.server.defs#webhook"
              }
            }
          }
        },
        "errors": [
          {
            "name": "InvalidUrl",
            "description": "The provided webhook URL is invalid or unreachable."
          },
          {
            "name": "DuplicateWebhook",
            "description": "A webhook with this URL already exists for this user."
          },
          {
            "name": "TooManyWebhooks",
            "description": "The user has reached their maximum number of webhooks."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.defs",
    "defs": {
      "webhook": {
        "type": "object",
        "description": "A webhook configuration for receiving Streamplace events.",
        "required": [
          "id",
          "url",
          "events",
          "active",
          "createdAt"
        ],
        "properties": {
          "id": {
            "type": "string",
            "description": "Unique identifier for this webhook."
          },
          "url": {
            "type": "string",
            "format": "uri",
            "description": "The webhook URL where events will be sent."
          },
          "events": {
            "type": "array",
            "items": {
              "type": "string",
              "enum": [
                "chat",
                "livestream",
                "follow",
                "mention",
                "stream.received"
              ]
            },
            "description": "The types of events this webhook should receive."
          },
          "active": {
            "type": "boolean",
            "description": "Whether this webhook is currently active."
          },
          "prefix": {
            "type": "string",
            "maxLength": 100,
            "description": "Text to prepend to webhook messages."
          },
          "suffix": {
            "type": "string",
            "maxLength": 100,
            "description": "Text to append to webhook messages."
          },
          "rewrite": {
            "type": "array",
            "items": {
              "type": "ref",
              "ref": "#rewriteRule"
            },
            "description": "Text replacement rules for webhook messages."
          },
          "createdAt": {
            "type": "string",
            "format": "datetime",
            "description": "When this webhook was created."
          },
          "updatedAt": {
            "type": "string",
            "format": "datetime",
            "description": "When this webhook was last updated."
          },
          "name": {
            "type": "string",
            "maxLength": 100,
            "description": "A user-friendly name for this webhook."
          },
          "description": {
            "type": "string",
            "maxLength": 500,
            "description": "A description of what this webhook is used for."
          },
          "lastTriggered": {
            "type": "string",
            "format": "datetime",
            "description": "When this webhook was last triggered."
          },
          "errorCount": {
            "type": "integer",
            "description": "Number of consecutive errors for this webhook."
          },
          "muteWords": {
            "type": "array",
            "items": {
              "type": "string",
              "maxLength": 100
            },
            "description": "Words to filter out from chat messages. Messages containing any of these words will not be forwarded."
          }
        }
      },
      "rewriteRule": {
        "type": "object",
        "required": [
          "from",
          "to"
        ],
        "properties": {
          "from": {
            "type": "string",
            "maxLength": 100,
            "minLength": 1,
            "description": "Text to search for and replace."
          },
          "to": {
            "type": "string",
            "maxLength": 100,
            "description": "Text to replace with."
          }
        }
      },
      "storage": {
        "type": "object",
        "description": "S3 storage configuration for backups.",
        "required": [
          "url",
          "isActive"
        ],
        "properties": {
          "url": {
            "type": "string",
            "description": "S3 storage URL with masked secret key in format: s3+https://ACCESS_KEY:***@endpoint/bucket"
          },
          "isActive": {
            "type": "boolean",
            "description": "Whether backup storage is currently active."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.deleteStorage",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Delete S3 storage configuration.",
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "success"
            ],
            "properties": {
              "success": {
                "type": "boolean"
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.deleteWebhook",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Delete an existing webhook.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "id"
            ],
            "properties": {
              "id": {
                "type": "string",
                "description": "The ID of the webhook to delete."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "success"
            ],
            "properties": {
              "success": {
                "type": "boolean",
                "description": "Whether the webhook was successfully deleted."
              }
            }
          }
        },
        "errors": [
          {
            "name": "WebhookNotFound",
            "description": "The specified webhook was not found."
          },
          {
            "name": "Unauthorized",
            "description": "The authenticated user does not have access to this webhook."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.getServerTime",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get the current server time for client clock synchronization",
        "parameters": {
          "type": "params",
          "properties": {}
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "serverTime"
            ],
            "properties": {
              "serverTime": {
                "type": "string",
                "format": "datetime",
                "description": "Current server time in RFC3339 format"
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.getStorage",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get S3 storage configuration (with masked secret key).",
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {
              "storage": {
                "type": "ref",
                "ref": "place.stream.server.defs#storage"
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.getWebhook",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get details for a specific webhook.",
        "parameters": {
          "type": "params",
          "required": [
            "id"
          ],
          "properties": {
            "id": {
              "type": "string",
              "description": "The ID of the webhook to retrieve."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "webhook"
            ],
            "properties": {
              "webhook": {
                "type": "ref",
                "ref": "place.stream.server.defs#webhook"
              }
            }
          }
        },
        "errors": [
          {
            "name": "WebhookNotFound",
            "description": "The specified webhook was not found."
          },
          {
            "name": "Unauthorized",
            "description": "The authenticated user does not have access to this webhook."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.listWebhooks",
    "defs": {
      "main": {
        "type": "query",
        "description": "List webhooks for the authenticated user.",
        "parameters": {
          "type": "params",
          "properties": {
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 50,
              "description": "The number of webhooks to return."
            },
            "cursor": {
              "type": "string",
              "description": "An optional cursor for pagination."
            },
            "active": {
              "type": "boolean",
              "description": "Filter webhooks by active status."
            },
            "event": {
              "type": "string",
              "enum": [
                "chat",
                "livestream",
                "follow",
                "mention",
                "stream.received"
              ],
              "description": "Filter webhooks that handle this event type."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "webhooks"
            ],
            "properties": {
              "webhooks": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.server.defs#webhook"
                }
              },
              "cursor": {
                "type": "string",
                "description": "A cursor for pagination, if there are more results."
              }
            }
          }
        },
        "errors": [
          {
            "name": "InvalidCursor",
            "description": "The provided cursor is invalid or expired."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.settings",
    "defs": {
      "main": {
        "type": "record",
        "description": "Record containing user settings for a particular Streamplace node",
        "key": "any",
        "record": {
          "type": "object",
          "required": [],
          "properties": {
            "debugRecording": {
              "type": "boolean",
              "description": "Whether this node may archive your livestream for improving the service"
            },
            "livestreamRecording": {
              "type": "boolean",
              "description": "Whether this node should record your livestreams into VODs that you can publish"
            },
            "autoPublishVods": {
              "type": "boolean",
              "description": "Whether this node should publish the VOD of each of your recorded livestreams as soon as it ends"
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.updateWebhook",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Update an existing webhook configuration.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "id"
            ],
            "properties": {
              "id": {
                "type": "string",
                "description": "The ID of the webhook to update."
              },
              "url": {
                "type": "string",
                "format": "uri",
                "description": "The webhook URL where events will be sent."
              },
              "events": {
                "type": "array",
                "items": {
                  "type": "string",
                  "enum": [
                    "chat",
                    "livestream",
                    "follow",
                    "mention",
                    "stream.received"
                  ]
                },
                "description": "The types of events this webhook should receive."
              },
              "active": {
                "type": "boolean",
                "description": "Whether this webhook should be active."
              },
              "prefix": {
                "type": "string",
                "maxLength": 100,
                "description": "Text to prepend to webhook messages."
              },
              "suffix": {
                "type": "string",
                "maxLength": 100,
                "description": "Text to append to webhook messages."
              },
              "rewrite": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.server.defs#rewriteRule"
                },
                "description": "Text replacement rules for webhook messages."
              },
              "name": {
                "type": "string",
                "maxLength": 100,
                "description": "A user-friendly name for this webhook."
              },
              "description": {
                "type": "string",
                "maxLength": 500,
                "description": "A description of what this webhook is used for."
              },
              "muteWords": {
                "type": "array",
                "items": {
                  "type": "string",
                  "maxLength": 100
                },
                "description": "Words to filter out from chat messages. Messages containing any of these words will not be forwarded."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "webhook"
            ],
            "properties": {
              "webhook": {
                "type": "ref",
                "ref": "place.stream.server.defs#webhook"
              }
            }
          }
        },
        "errors": [
          {
            "name": "WebhookNotFound",
            "description": "The specified webhook was not found."
          },
          {
            "name": "Unauthorized",
            "description": "The authenticated user does not have access to this webhook."
          },
          {
            "name": "InvalidUrl",
            "description": "The provided webhook URL is invalid or unreachable."
          },
          {
            "name": "DuplicateWebhook",
            "description": "A webhook with this URL already exists for this user."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.server.upsertStorage",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create or update S3 storage configuration for backups.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [],
            "properties": {
              "url": {
                "type": "string",
                "description": "S3 storage URL in format: s3+https://ACCESS_KEY:SECRET_KEY@endpoint/bucket"
              },
              "isActive": {
                "type": "boolean",
                "description": "Whether backup storage is currently active."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "storage"
            ],
            "properties": {
              "storage": {
                "type": "ref",
                "ref": "place.stream.server.defs#storage"
              }
            }
          }
        },
        "errors": [
          {
            "name": "InvalidUrl",
            "description": "The provided S3 URL is invalid or malformed."
          },
          {
            "name": "ConnectionFailed",
            "description": "Could not connect to the S3 endpoint with the provided credentials."
          },
          {
            "name": "MaskedCredentialsModified",
            "description": "Cannot modify URL while keeping masked credentials. Provide full credentials or omit URL to keep existing configuration."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.video",
    "defs": {
      "main": {
        "type": "record",
        "description": "Some audiovisual content.",
        "key": "tid",
        "record": {
          "required": [
            "title",
            "source",
            "durationMs",
            "createdAt"
          ],
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 1400,
              "maxGraphemes": 140,
              "description": "Title of the video referenced by this record"
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Timestamp when this video record was created. Populated server-side at publication time by place.stream.media.publishVideo."
            },
            "source": {
              "type": "union",
              "refs": [
                "place.stream.media.defs#sourceTracks",
                "place.stream.media.defs#sourceClip"
              ],
              "description": "What is the source of this video?"
            },
            "description": {
              "type": "string",
              "maxLength": 50000,
              "maxGraphemes": 5000,
              "description": "Description of this video"
            },
            "durationMs": {
              "type": "integer",
              "description": "Duration of the video in milliseconds"
            },
            "descriptionFacets": {
              "type": "array",
              "description": "Annotations of text (mentions, URLs, etc)",
              "items": {
                "type": "ref",
                "ref": "place.stream.richtext.videoFacet"
              }
            },
            "thumb": {
              "description": "Thumbnail image for the video.",
              "type": "blob",
              "accept": [
                "image/*"
              ],
              "maxSize": 1000000
            },
            "connections": {
              "type": "array",
              "description": "Free-form list of atproto records related in some way to this video",
              "items": {
                "type": "union",
                "refs": [
                  "#connection"
                ]
              }
            },
            "contentWarnings": {
              "description": "content warning data for this VOD",
              "type": "ref",
              "ref": "place.stream.metadata.contentWarnings"
            },
            "contentRights": {
              "description": "copyright and licensing information for this VOD",
              "type": "ref",
              "ref": "place.stream.metadata.contentRights"
            },
            "activity": {
              "type": "union",
              "description": "The game or activity in the video.",
              "refs": [
                "place.stream.defs#activityGame",
                "place.stream.defs#activityLabel"
              ]
            },
            "tags": {
              "type": "array",
              "description": "Freeform tags for this stream. Each tag must be alphanumeric (a-z, A-Z, 0-9) plus colon. Tags with colons indicate a specific tag group (e.g. 'lang:en' indicates the stream's primary language).",
              "maxLength": 10,
              "items": {
                "type": "string",
                "maxLength": 640,
                "maxGraphemes": 64
              }
            }
          }
        }
      },
      "connection": {
        "type": "object",
        "properties": {
          "ref": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.comment",
    "defs": {
      "main": {
        "type": "record",
        "description": "Record containing a comment on a VOD.",
        "key": "tid",
        "record": {
          "type": "object",
          "required": [
            "text",
            "createdAt",
            "video"
          ],
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 3000,
              "maxGraphemes": 300,
              "description": "The comment text content."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime",
              "description": "Client-declared timestamp when this comment was created."
            },
            "video": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the place.stream.video record this comment belongs to."
            },
            "facets": {
              "type": "array",
              "description": "Annotations of text (mentions, URLs, etc)",
              "items": {
                "type": "ref",
                "ref": "place.stream.richtext.facet"
              }
            },
            "reply": {
              "type": "ref",
              "ref": "#replyRef"
            }
          }
        }
      },
      "replyRef": {
        "type": "object",
        "required": [
          "root",
          "parent"
        ],
        "properties": {
          "root": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef"
          },
          "parent": {
            "type": "ref",
            "ref": "com.atproto.repo.strongRef"
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.createDraft",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Create an empty draft VOD in the 'processing' state. The draft is the durable anchor for an upload: the client creates it first, then passes its URI to place.stream.media.createUpload so the upload's processing fills this draft. Lets the user start editing metadata while the upload runs, and supports re-upload (a failed upload leaves the draft intact; a new createUpload with the same draftUri re-points it).",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {}
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "description": "The ats:// URI of the newly created draft record."
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.defs",
    "defs": {
      "commentView": {
        "type": "object",
        "required": [
          "uri",
          "cid",
          "author",
          "record",
          "indexedAt",
          "likeCount"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          },
          "indexedAt": {
            "type": "string",
            "format": "datetime"
          },
          "replyTo": {
            "type": "union",
            "refs": [
              "#commentViewBasic"
            ],
            "description": "The parent comment this one replies to, if any. A non-recursive view (it carries no replyTo of its own), so the thread is flattened to a single hop; walk `record.reply` to follow the chain further."
          },
          "likeCount": {
            "type": "integer",
            "minimum": 0,
            "description": "Number of likes on this comment."
          }
        }
      },
      "commentViewBasic": {
        "type": "object",
        "description": "A comment view without its own `replyTo`, used to represent the parent of a reply without recursively nesting the whole thread.",
        "required": [
          "uri",
          "cid",
          "author",
          "record",
          "indexedAt",
          "likeCount"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "format": "at-uri"
          },
          "cid": {
            "type": "string",
            "format": "cid"
          },
          "author": {
            "type": "ref",
            "ref": "app.bsky.actor.defs#profileViewBasic"
          },
          "record": {
            "type": "unknown"
          },
          "indexedAt": {
            "type": "string",
            "format": "datetime"
          },
          "likeCount": {
            "type": "integer",
            "minimum": 0,
            "description": "Number of likes on this comment."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.deleteDraft",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Discard a draft VOD. The processed content blob is not deleted (it may be referenced elsewhere). Only the draft record is removed.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "description": "The ats:// URI of the draft to discard."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "properties": {}
          }
        },
        "errors": [
          {
            "name": "NotFound",
            "description": "No draft exists with the given URI for the authenticated user."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.draftDefs",
    "defs": {
      "draftView": {
        "type": "object",
        "description": "A draft VOD with its ats:// URI and CID, for list/get responses.",
        "required": [
          "uri",
          "cid",
          "record"
        ],
        "properties": {
          "uri": {
            "type": "string",
            "description": "The ats:// URI of the draft record."
          },
          "cid": {
            "type": "string",
            "description": "CID (sha256 of CBOR record bytes, base32) of the draft record."
          },
          "record": {
            "type": "unknown",
            "description": "The place.stream.vod.draftVideo record body. Typed as unknown (matching commentView/livestreamView/videoView) because the @atproto/api client validator cannot validate a ref to a record-type lexicon."
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.draftVideo",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "A draft VOD: pre-publication video metadata and processing state. Modeled as a permissioned-data-style record (CBOR-serialized, addressed by an ats:// URI) stored in statedb until the permissioned-data spec ships (bluesky-social/proposals PR #94, the 0016-permissioned-data proposal). Publishing promotes it to a public place.stream.video record.",
        "record": {
          "type": "object",
          "required": [
            "title",
            "status",
            "createdAt"
          ],
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 1400,
              "maxGraphemes": 140,
              "description": "Title of the video. May be a placeholder while processing; the user edits before publishing."
            },
            "description": {
              "type": "string",
              "maxLength": 50000,
              "maxGraphemes": 5000,
              "description": "Description of the video."
            },
            "descriptionFacets": {
              "type": "array",
              "description": "Annotations of text (mentions, URLs, etc).",
              "items": {
                "type": "ref",
                "ref": "place.stream.richtext.videoFacet"
              }
            },
            "thumb": {
              "type": "blob",
              "accept": [
                "image/*"
              ],
              "maxSize": 1000000,
              "description": "Thumbnail image. Generated by the server at publish time if absent."
            },
            "source": {
              "type": "union",
              "refs": [
                "place.stream.media.defs#sourceTracks",
                "place.stream.media.defs#sourceClip"
              ],
              "description": "Source tracks. Filled by the server when processing completes (status 'ready')."
            },
            "durationMs": {
              "type": "integer",
              "description": "Duration in milliseconds. Filled when status is 'ready'."
            },
            "activity": {
              "type": "union",
              "description": "The game or activity in the video.",
              "refs": [
                "place.stream.defs#activityGame",
                "place.stream.defs#activityLabel"
              ]
            },
            "tags": {
              "type": "array",
              "maxLength": 10,
              "description": "Freeform tags (same rules as place.stream.video).",
              "items": {
                "type": "string",
                "maxLength": 640,
                "maxGraphemes": 64
              }
            },
            "connections": {
              "type": "array",
              "description": "Related records (e.g. the source livestream for a finalized VOD).",
              "items": {
                "type": "union",
                "refs": [
                  "place.stream.video#connection"
                ]
              }
            },
            "contentWarnings": {
              "type": "ref",
              "ref": "place.stream.metadata.contentWarnings"
            },
            "contentRights": {
              "type": "ref",
              "ref": "place.stream.metadata.contentRights"
            },
            "status": {
              "type": "string",
              "knownValues": [
                "processing",
                "ready",
                "error"
              ],
              "description": "Processing state: 'processing' while the job runs, 'ready' when publishable, 'error' if processing failed."
            },
            "error": {
              "type": "string",
              "description": "Error message when status is 'error'."
            },
            "createdAt": {
              "type": "string",
              "format": "datetime"
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.gate",
    "defs": {
      "main": {
        "type": "record",
        "key": "tid",
        "description": "Record defining a single gated VOD comment.",
        "record": {
          "type": "object",
          "required": [
            "hiddenComment"
          ],
          "properties": {
            "hiddenComment": {
              "type": "string",
              "format": "at-uri",
              "description": "URI of the hidden VOD comment."
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.getComments",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get comments for a place.stream.video record.",
        "parameters": {
          "type": "params",
          "required": [
            "video"
          ],
          "properties": {
            "video": {
              "type": "string",
              "format": "at-uri",
              "description": "AT-URI of the place.stream.video record."
            },
            "cursor": {
              "type": "string",
              "description": "Optional pagination cursor."
            },
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 50,
              "description": "Maximum number of comments to return."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "comments"
            ],
            "properties": {
              "cursor": {
                "type": "string"
              },
              "comments": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.vod.defs#commentView"
                }
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.getDraft",
    "defs": {
      "main": {
        "type": "query",
        "description": "Get a single draft VOD by its ats:// URI. Only accessible by the draft's author.",
        "parameters": {
          "type": "params",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "description": "The ats:// URI of the draft record."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "draft"
            ],
            "properties": {
              "draft": {
                "type": "ref",
                "ref": "place.stream.vod.draftDefs#draftView"
              }
            }
          }
        },
        "errors": [
          {
            "name": "NotFound",
            "description": "No draft exists with the given URI for the authenticated user."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.listDrafts",
    "defs": {
      "main": {
        "type": "query",
        "description": "List the authenticated user's draft VODs, newest first.",
        "parameters": {
          "type": "params",
          "properties": {
            "limit": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100,
              "default": 50,
              "description": "Number of drafts to return."
            },
            "cursor": {
              "type": "string",
              "description": "Pagination cursor from a previous response."
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "drafts"
            ],
            "properties": {
              "drafts": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.vod.draftDefs#draftView"
                }
              },
              "cursor": {
                "type": "string",
                "description": "Pagination cursor for the next page, if more results exist."
              }
            }
          }
        }
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.publishDraft",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Promote a ready draft VOD to a public place.stream.video record. The server carries over source and durationMs from the draft, backfills a generated thumbnail if the draft has none, writes the video record via putRecord, then deletes the draft.",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "description": "The ats:// URI of the draft to publish. Must have status 'ready'."
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "videoUri",
              "videoCid"
            ],
            "properties": {
              "videoUri": {
                "type": "string",
                "format": "at-uri",
                "description": "AT-URI of the created place.stream.video record."
              },
              "videoCid": {
                "type": "string",
                "format": "cid",
                "description": "CID of the created place.stream.video record."
              }
            }
          }
        },
        "errors": [
          {
            "name": "NotFound",
            "description": "No draft exists with the given URI for the authenticated user."
          },
          {
            "name": "NotReady",
            "description": "The draft is not ready to publish (status is 'processing' or 'error')."
          }
        ]
      }
    }
  },
  {
    "lexicon": 1,
    "id": "place.stream.vod.updateDraft",
    "defs": {
      "main": {
        "type": "procedure",
        "description": "Update a draft VOD's editable metadata. Server-authoritative fields (source, durationMs, status) are preserved. Editing is allowed in any status, so the user can pre-fill metadata while processing. All fields except uri are optional (partial update).",
        "input": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "uri"
            ],
            "properties": {
              "uri": {
                "type": "string",
                "description": "The ats:// URI of the draft to update."
              },
              "title": {
                "type": "string",
                "maxLength": 1400,
                "maxGraphemes": 140
              },
              "description": {
                "type": "string",
                "maxLength": 50000,
                "maxGraphemes": 5000
              },
              "descriptionFacets": {
                "type": "array",
                "items": {
                  "type": "ref",
                  "ref": "place.stream.richtext.videoFacet"
                }
              },
              "thumb": {
                "type": "blob",
                "accept": [
                  "image/*"
                ],
                "maxSize": 1000000
              },
              "activity": {
                "type": "union",
                "refs": [
                  "place.stream.defs#activityGame",
                  "place.stream.defs#activityLabel"
                ]
              },
              "tags": {
                "type": "array",
                "maxLength": 10,
                "items": {
                  "type": "string",
                  "maxLength": 640,
                  "maxGraphemes": 64
                }
              },
              "contentWarnings": {
                "type": "ref",
                "ref": "place.stream.metadata.contentWarnings"
              },
              "contentRights": {
                "type": "ref",
                "ref": "place.stream.metadata.contentRights"
              }
            }
          }
        },
        "output": {
          "encoding": "application/json",
          "schema": {
            "type": "object",
            "required": [
              "draft"
            ],
            "properties": {
              "draft": {
                "type": "ref",
                "ref": "place.stream.vod.draftDefs#draftView"
              }
            }
          }
        },
        "errors": [
          {
            "name": "NotFound",
            "description": "No draft exists with the given URI for the authenticated user."
          }
        ]
      }
    }
  }
] as unknown as LexiconDoc[];
